import * as _ from "lodash";
import { Spread } from "../../grapecity";
import { WorkBookBase } from "./workbookBase";
import { DateTimeEditInterceptor, PasswordEditInterceptor, RequiredColumnHeaderCellType } from "./cellType";
import * as SPIRIT from "../../SPIRIT";



/**
 * カラムEditor（複合型）
 */
export class ColumnEditor {
    displayFormatter: string;
    editorFormatter: string;
    style?: Spread.Sheets.Style;
    cellType?: Spread.Sheets.CellTypes.Base;
}

/** */
export type columnDef = {
    name?: string;
    displayName?: string;
    width?: number;
    resizable?: boolean;
    value?: Function;
    size?: number | string;

    //type?: '' | 'number' | 'calendar' | 'color';
    //type?: Spread.Sheets.Style | Spread.Sheets.CellTypes.Base;
    editor?: Spread.Sheets.Style | Spread.Sheets.CellTypes.Base | ColumnEditor;

    /**関連項目Key名 */
    relatedTextTarget?: string;

    /** */
    required?: boolean;
    readonly?: boolean;
    /**Excel出力カスタマイズ項目 */
    export?: {
        headerBackColor?: string;
    }
    style?: {
        hAlign?: Spread.Sheets.HorizontalAlign;
        vAlign?: Spread.Sheets.VerticalAlign;
        formatter?: string | Spread.Formatter.GeneralFormatter;
        wordWrap?: boolean;
        //* { string | GC.Spread.Sheets.IPatternFill | GC.Spread.Sheets.IGradientFill | GC.Spread.Sheets.IGradientPathFill } backColor The background color.
        //* { string } foreColor The foreground color.
        //* { GC.Spread.Sheets.HorizontalAlign } hAlign The horizontal alignment.
        //* { GC.Spread.Sheets.VerticalAlign } vAlign The vertical alignment.
        //* { string } font The font.
        //* { string } themeFont The font theme.
        //* { string | GC.Spread.Formatter.GeneralFormatter } formatter The formatting object.
        //* { GC.Spread.Sheets.LineBorder } borderLeft The left border.
        //* { GC.Spread.Sheets.LineBorder } borderTop The top border.
        //* { GC.Spread.Sheets.LineBorder } borderRight The right border.
        //* { GC.Spread.Sheets.LineBorder } borderBottom The bottom border.
        //* { GC.Spread.Sheets.LineBorder } diagonalDown The diagonal with LeftTop to bottomRight.
        //* { GC.Spread.Sheets.LineBorder } diagonalUp The diagonal with topRight to bottomLeft.
        //* { boolean } locked Whether the cell, row, or column is locked.
        //* { number } textIndent The text indent amount.
        //* { boolean } wordWrap Whether words wrap within the cell or cells.
        //* { boolean } shrinkToFit Whether content shrinks to fit the cell or cells.
        //* { string } backgroundImage The background image to display.
        //* { GC.Spread.Sheets.CellTypes.Base } cellType The cell type.
        //* { GC.Spread.Sheets.ImageLayout } backgroundImageLayout The layout for the background image.
        //* { boolean } tabStop Whether the user can set focus to the cell using the Tab key.
        //* { GC.Spread.Sheets.TextDecorationType } textDecoration Specifies the decoration added to text.
        //* { GC.Spread.Sheets.ImeMode } imeMode Specifies the input method editor mode.
        //* { string } name Specifies the name.
        //* { string } parentName Specifies the name of the parent style.
        //* { string } watermark Specifies the watermark content.
        //* { string } cellPadding Specifies the cell padding.
        //* { Object } labelOptions Specifies the cell label options.
        //* { GC.Spread.Sheets.LabelAlignment } [labelOptions.alignment] The cell label position.
        //* { GC.Spread.Sheets.LabelVisibility } [labelOptions.visibility] The cell label visibility.
        //* { string } [labelOptions.font] The cell label font.
        //* { string } [labelOptions.foreColor] The cell label forecolor.
        //* { string } [labelOptions.margin] The cell label margin.
        //* { boolean } isVerticalText Whether to set the cell's text vertical.
        //* { number } textOrientation he cell text rotation angle.
    }

    //TODO
    //※廃止、コピーで非表示cellもコピーできてしまう!!
    //表示しないカラムは追加しないこと
    visible?: boolean;

    // #4119 データ検証を設定できるようにする。createXxxValidator()で引数が２つ以上あるものについては未対応とします。
    /**
     * データ検証のデータバリデーター(数式、数式リスト、リスト用)
     * */
    dataFomulaOrListValidator?: {
        /** データ検証の種別 */
        type: ValidationType;
        /** データバリデーター */
        value: string;
        /** 空白を無視するかどうか */
        isIgnoreBlank?: boolean;
        /** 入力タイトルと入力メッセージを表示するかどうか */
        isShowInputMessage?: boolean;
        /** 入力タイトル */
        inputTitle?: string;
        /** 入力メッセージ */
        inputMessage?: string;
        /** エラーメッセージの表示有無 */
        isShowErrorMessage?: boolean;
        /** エラータイトル */
        errorTitle?: string;
        /** エラーメッセージ */
        errorMessage?: string;
    }

}

// #4119 データ検証用の定義
/** データ検証種別 */
export enum ValidationType {
    // 現状は使う予定が無いので、コメントアウトしておく
    ///** 数値に基づくバリデーターを作成します */
    //Number,
    ///** 日付に基づくバリデーターを作成します */
    //Date,
    ///** テキストの長さに基づくバリデーターを作成します */
    //TextLength,
    /** 数式に基づくバリデーターを作成します */
    Formula,
    /** 数式リストに基づくバリデーターを作成します */
    FormulaList,
    /** リストに基づくバリデーターを作成します */
    List,
}


/** 
 *  データ元情報
 */
export type Source = {
    /** 取得先URL*/
    url?: string;
    /** 元データ（加工前）*/
    //data?: any[];
    data?: any;
}


/**
 * 基本シート
 * 生成されたworkSheetのFacade
 */
export abstract class WorkSheetBase {


    /***/
    public spread: WorkBookBase;



    /**
     * Workbook(Raw)
     */
    //protected rawSpread: Spread.Sheets.Workbook;
    protected get rawSpread(): Spread.Sheets.Workbook {
        return this.spread?.rawSpread;
    }

    /**
     *  Worksheet(Raw)
     */
    public rawSheet: Spread.Sheets.Worksheet;

    /**
     * filter インスタンス
     */
    public filter: Spread.Sheets.Filter.HideRowFilter;

    /**
     * シート名
     */
    public sheetName: string;

    /**
     * 高さ自動調整を実行するかどうか
     * ※WordWrap:trueのカラムが一件でもある場合、自動調整になるが、本変数がfalseの場合、自動調整をしない
     */
    public doAutoFit: boolean = true;

    /**
     * シートNO
     * @deprecated
     */
    //public sheetNo: number;
    public get sheetNo(): number {
        return this.rawSpread?.getSheetIndex(this.sheetName) || -1;
    }

    /**
     *  アクティブシートかどうか
     */
    public get isActive(): boolean {

        return this.rawSpread?.getActiveSheet() === this.rawSheet;
    }

    /**
     *  シートに設定するデータの情報
     *
     */
    public source: Source = {};

    /**
     *  シートで参照するデータの情報
     *  (コンボボックスなどのデータ情報)
     */
    //public referenceSource: Source[];
    /**
     *  カラム定義
     */
    public columns: columnDef[] = [];


    /**
     */
    protected get mode(): SPIRIT.constant.GridMode {
        //this.spread?.
        //return SPIRIT.constant.GridMode.VIEW;
        //return SPIRIT.constant.GridMode.EDIT;
        return this.spread?.mode;

    }


    /**
     * 変更管理区分列、データKey
     */
    public static readonly KEY_SectionType = 'SectionType';
    public static readonly KEY_SectionType_Display = '区分';

    /**
     * 取込管理区分列、データKey
     */
    public static readonly KEY_ImportType = 'ImportType';
    public static readonly KEY_ImportType_Display = '取込区分';

    /**
    * エクスポート時のシステムカラム
    */
    public static readonly KEY_UpdateUserName = 'UpdateUserName';
    public static readonly KEY_UpdateUserName_Display = '更新ユーザ名';
    public static readonly KEY_UpdateUserLoginId = 'UpdateUserLoginId';
    public static readonly KEY_UpdateUserLoginId_Display = '更新ログインID';
    public static readonly KEY_UpdateDateString = 'UpdateDateString';
    public static readonly KEY_UpdateDateString_Display = '更新日時';



    /**
     * 新規登録用の余白行Key
     */
    public static readonly KEY_isBlank = 'isBlank';

    /**
     * 変更管理区分列が必要か
     */
    public isNeedSectionTypeColumn: boolean = true;

    /**
     * 取込管理区分列が必要か
     */
    public isNeedImportTypeTypeColumn: boolean = true;

    /**
     * 新規登録用の余白行が必要か
     */
    public isNeedExtraRow: boolean = true;

    /**
     * Filterが必要か
     */
    public isNeedFilter: boolean = true;

    /** */
    public filterOptions: {
        // sortByValueを非表示にする。
        sortByValue?: boolean,
        // 色で並べ替え
        sortByColor?: boolean,
        // 色フィルター
        filterByColor?: boolean,
        // テキストフィルター
        filterByValue?: boolean,
        // 選択肢リスト
        listFilterArea?: boolean
    };



    /**
     * 新規登録用行カウント
     */
    public extraRowCount: number = 50;

    /**
     *初期拡大率　0.85
     */
    //public initZoomfactor: number = 0.85;
    public initZoomfactor: number = SPIRIT.constant.SPREAD_INITIAL_ZOOM;

    /**
     * デフォルト行高さ
     */
    public defaultsRowHeight: number = null;


    /****/
    public get shouldSectionTypeColumn(): boolean {
        if (this.mode == SPIRIT.constant.GridMode.EDIT && this.isNeedSectionTypeColumn) {
            return true;
        }
        return false;
    }

    /****/
    public get shouldImportTypeColumn(): boolean {
        if (this.mode == SPIRIT.constant.GridMode.IMPORT && this.isNeedImportTypeTypeColumn) {
            return true;
        }
        return false;
    }

    /****/
    public get shouldNeedExtraRow(): boolean {
        if (this.mode == SPIRIT.constant.GridMode.EDIT && this.isNeedExtraRow) {
            return true;
        }
        return false;
    }

    /**
     *  spread sheetOption
     *
     *  allowCellOverflow  ：  boolean  ：  データが隣接する空白セルにオーバーフローできるかどうかを指定します（オプション）。
     *  sheetTabColor  ：  string  ：  シートタブの色を表す色文字列（オプション）。"red"、"#FFFF00"、"rgb(255,0,0)"、"Accent 5"など。
     *  frozenlineColor  ：  string  ：  固定線の色を表す色文字列（オプション）。"red"、"#FFFF00"、"rgb(255,0,0)"、"Accent 5"など。
     *  clipBoardOptions  ： GC.Spread.Sheets.ClipboardPasteOptions  ：  クリップボードオプション（オプション）。
     *  gridline  ：  object ：  グリッド線のオプション（オプション）。
     *  gridline.color  ：  string  ：  グリッド線の色（オプション）。
     *  gridline.showVerticalGridline  ：  boolean  ：  垂直グリッド線を表示するかどうかを指定します（オプション）。
     *  gridline.showHorizontalGridline  ：  boolean  ：  水平グリッド線を表示するかどうかを指定します（オプション）。
     *  rowHeaderVisible  ：  boolean  ：  行ヘッダが表示されるかどうかを指定します（オプション）。
     *  colHeaderVisible  ：  boolean  ：  列ヘッダが表示されるかどうかを指定します（オプション）。
     *  rowHeaderAutoText  ：  GC.Spread.Sheets.HeaderAutoText  ：  行ヘッダに英字または数字を表示するか、空白にするかを指定します（オプション）。
     *  colHeaderAutoText  ：  GC.Spread.Sheets.HeaderAutoText  ：  列ヘッダに英字または数字を表示するか、空白にするかを指定します（オプション）。
     *  rowHeaderAutoTextIndex  ：  number  ：  複数の行ヘッダ列があるときに自動テキストを表示する行ヘッダ列を指定します（オプション）。
     *  colHeaderAutoTextIndex  ：  number  ：  複数の列ヘッダ行があるときに自動テキストを表示する列ヘッダ行を指定します（オプション）。
     *  isProtected  ：  boolean  ：  このシート上の保護対象としてマークされたセルを編集できないかどうかを指定します（オプション）。
     *  protectionOptions  ：  object  ：  ユーザーが変更できるようにする要素を示す値（オプション）。
     *  protectionOptions.allowSelectLockedCells  ：  boolean  ：  ユーザーがロックされたセルを選択できるかどうかを指定します（オプション）。
     *  protectionOptions.allowSelectUnlockedCells  ：  boolean  ：  ユーザーがロックされていないセルを選択できるかどうかを指定します（オプション）。
     *  protectionOptions.allowSort  ：  boolean  ：  ユーザーが範囲をソートできるかどうかを指定します（オプション）。
     *  protectionOptions.allowFilter  ：  boolean  ：  ユーザーが範囲をフィルタリングできるかどうかを指定します（オプション）。
     *  protectionOptions.allowEditObjects  ：  boolean  ：  ユーザーがフローティングオブジェクトを編集できるかどうかを指定します（オプション）。
     *  protectionOptions.allowResizeRows  ：  boolean  ：  ユーザーが行をサイズ変更できるかどうかを指定します（オプション）。
     *  protectionOptions.allowResizeColumns  ：  boolean  ：  ユーザーが列をサイズ変更できるかどうかを指定します（オプション）。
     *  protectionOptions.allowDragInsertRows  ：  boolean  ：  ユーザーがドラッグ操作によって行を挿入できるかどうかを指定します。
     *  protectionOptions.allowDragInsertColumns  ：  boolean  ：  ユーザーがドラッグ操作によって列を挿入できるかどうかを指定します。
     *  protectionOptions.allowInsertRows  ：  boolean  ：  ユーザーが行を挿入できるかどうかを指定します。
     *  protectionOptions.allowInsertColumns  ：  boolean  ：  ユーザーが列を挿入できるかどうかを指定します。
     *  protectionOptions.allowDeleteRows  ：  boolean  ：  ユーザーが行を削除できるかどうかを指定します。
     *  protectionOptions.allowDeleteColumns  ：  boolean  ：  ユーザーが列を削除できるかどうかを指定します。
     *  selectionBackColor  ：  string  ：  シートの選択の背景色（オプション）。
     *  selectionBorderColor  ：  string  ：  シートの選択の境界線の色（オプション）。
     *  sheetAreaOffset  ：  Object  ：  sheetAreaOffsetのオプション（オプション）。
     *  sheetAreaOffset.left  ：  number  ：  シートの、ホストからの左オフセット（オプション）。
     *  sheetAreaOffset.top  ：  number    シートの、ホストからの上オフセット（オプション）。
     *  
     *  @see https://docs.grapecity.com/help/spread-js/sheets/#SpreadJS~GC.Spread.Sheets.Worksheet~_ctor.html
     */
    public options: {};


    /**
     * シートに投入した生データ(dataSourceで指定されたdataは加工が必要だったりするので、加工後、直接投入する直前のデータ)
     */
    public rawData: any[];
    //public rawData: any;

    /**
     * コンボボックスに投入した生データ
     * key：コンボボックス作成時のvalueName / value：Source
     */
    private dropDownSources: any = {};

    /**
     * インポート前DBデータ
     */
    public beforeImportDbData: any[] = [];

    /**
    * 非同期処理のプロミスをざっくり管理
    * (登録しておくと、workBookのMainPromiseにラインアップ登録されます。つまり、workBookのCreatePromiseにその状態を登録できます)
    */
    private miscellanyPromises: Promise<any>[] = [];

    /**
    * 非同期処理のプロミスに登録
    * コンボなどの参照用のデータをRemoteから取得する際などに登録しても良い
    * 登録しておいて、使用しなくてもいい
    * とにかく、ケースバイで、後の処理でresolveを保証したい場合などに使用する
    * (登録しておくと、workBookのMainPromiseにラインアップ登録されます。つまり、workBookのCreatePromiseにその状態を登録できます)
    */
    protected registPromises(p: Promise<any>) {
        this.miscellanyPromises = this.miscellanyPromises || [];
        this.miscellanyPromises.push(p);
    }

    /**
    * 非同期処理のプロミス群を取得（公開用）
    * (登録しておくと、workBookのMainPromiseにラインアップ登録されます。つまり、workBookのCreatePromiseにその状態を登録できます)
    */
    public get miscPromises(): Promise<any>[] {
        return this.miscellanyPromises;
    }
    /** */
    protected clearPromises() {
        this.miscPromises.slice(0);
        this.miscellanyPromises = null;
        this.miscellanyPromises = [];
    }


    /**
     *シートに基本設定されているprotectionOptionsを保持する
     * （活性制御に使用する、isProtected=true,falseの切り替えだけでは完全に制御出来ないシートもあるはず
     */
    tempProtectionOptions: any = null;

    /**
     *非活性状態直前のセルStyle（locked）を保持する
     * （活性制御に使用する、isProtected=true,falseの切り替えだけでは完全に制御出来ないシートもあるはず
     */
    tempCellStyleSettings: any[];


    /**
     * 活性状態
     * @param disabled
     */
    private _disabled: boolean = false;

    /**
     * 活性状態
     */
    get disabled(): boolean {
        //return this.rawSheet?.options.isProtected;
        return this._disabled;
    }

    /**
     * 活性制御
     * @param disabled
     */
    set disabled(disabled: boolean) {
        this._disabled = disabled;

        if (this.rawSheet) {
            if (this.tempProtectionOptions == null) {
                this.tempProtectionOptions = {};
                //当初のProtectionOptionsとisProtectedを保持する
                _.assign(this.tempProtectionOptions,
                    {
                        isProtected: this.rawSheet.options.isProtected,
                        protectionOptions: _.cloneDeep(this.rawSheet.options.protectionOptions)
                    });
            }

            if (disabled) {

                //
                //https://docs.grapecity.com/help/spread-js/sheets/#styles.html
                //セルのスタイルは、優先順位に基づいて適用された各種設定の組み合わせです。セルに対するスタイルは、優先度が最高となります。
                //次に優先度が高いのは、このセルが属する行のスタイルであり、このセルが属する列のスタイルがその次、最後はシートのデフォルトスタイルです。
                //Styleオブジェクトを割り当てるには、setStyleメソッドを使用します。行全体または列全体を指定するには、「-1」を使用します。

                //「ボツ１」 jsonシリアライズ/デシリアライズ
                //・場合により重そう。
                //・さらに再描画が走りちらつく
                //・コンボボックス等のインスタンス参照が切れそう（かも）
                //if (this.tempCellStyleSettingJson == null) {
                //    this.tempCellStyleSettingJson = this.rawSheet.toJSON({ includeBindingSource: true });
                //}
                ////this.rawSheet.getRange(-1, -1, -1, -1).locked(true);//これではセル毎に設定されている場合、そっちが優先される(defaultDataNodeと言われるsheet全体の設定に入る)
                //this.rawSheet.getRange(0, 0, this.rawSheet.getRowCount(), this.rawSheet.getColumnCount()).locked(true);//


                //「ボツ２」
                //var namedStyle = new Spread.Sheets.Style();
                //namedStyle.name = "disabled";
                //namedStyle.locked = true;
                //this.rawSheet.addNamedStyle(namedStyle);
                //this.rawSheet.getCell(1, 5).locked();
                //this.rawSheet.getActualStyle(1, 5).locked;
                //this.rawSheet.setStyleName(-1, -1, "disabled");
                //// 描画停止
                //this.rawSpread.suspendPaint();
                //// ロック解除
                ////for (var row = 0; row < this.getRowCount(); row++) {
                //for (var col = 0; col < this.getColumnCount(); col++) {
                //    this.rawSheet.setStyleName(-1, col, 'disabled');
                //}
                /////}
                //this.rawSpread.resumePaint();

                this.rawSpread.suspendCalcService();
                this.rawSpread.suspendEvent();
                this.rawSpread.suspendPaint();
                this.tempCellStyleSettings = [];
                for (var row = 0; row < this.getRowCount(); row++) {
                    let cols = [];
                    for (var col = 0; col < this.getColumnCount(); col++) {
                        //セル単品に設定されたstyleのみ抽出
                        //セルに指定されていない場合はnullになっていることはありうる。その場合はカラムに指定されているstyleが当たっているだろう
                        //(上記のコメントの通り優先順位：全体＜カラム＜行＜セル)
                        //クローンして参照を切らないと、後で全体で設定するlock処理で共に変わってしまう
                        //let colStyle = this.rawSheet.getStyle(row, col;
                        let colStyle = this.rawSheet.getStyle(row, col)?.clone() || null;
                        cols.push(colStyle);
                    }
                    this.tempCellStyleSettings.push(cols);
                }

                //this.rawSheet.getRange(-1, -1, -1, -1).locked(true);//これではセル毎に設定されている場合、そっちが優先される(defaultDataNodeと言われるsheet全体の設定に入る)
                this.rawSheet.getRange(0, 0, this.rawSheet.getRowCount(), this.rawSheet.getColumnCount()).locked(true);//
                this.rawSpread.resumePaint();
                this.rawSpread.resumeEvent();
                this.rawSpread.resumeCalcService();

                //
                this.rawSheet.options.isProtected = true;
                //
                this.rawSheet.options.protectionOptions = {
                    //ユーザーがロックされたセルを選択できるかどうかを指定します（オプション）。
                    allowSelectLockedCells: true,
                    //ユーザーがロックされていないセルを選択できるかどうかを指定します（オプション）。
                    allowSelectUnlockedCells: true,
                    //ユーザーが範囲をソートできるかどうかを指定します（オプション）。
                    allowSort: true,
                    //ユーザーが範囲をフィルタリングできるかどうかを指定します（オプション）。
                    allowFilter: true,
                    //ユーザーがフローティングオブジェクトを編集できるかどうかを指定します（オプション）。
                    allowEditObjects: false,
                    //ユーザーが行をサイズ変更できるかどうかを指定します（オプション）。
                    //#2616,2617,2656 行高さ調整は基本できない。
                    allowResizeRows: false,
                    //ユーザーが列をサイズ変更できるかどうかを指定します（オプション）。
                    allowResizeColumns: true,
                    // ユーザーがドラッグ操作によって行を挿入できるかどうかを指定します。
                    allowDragInsertRows: false,
                    // ユーザーがドラッグ操作によって列を挿入できるかどうかを指定します。
                    allowDragInsertColumns: false,
                    //ユーザーが行を挿入できるかどうかを指定します。
                    allowInsertRows: false,
                    //ユーザーが列を挿入できるかどうかを指定します。
                    allowInsertColumns: false,
                    // ユーザーが行を削除できるかどうかを指定します。
                    allowDeleteRows: false,
                    //ユーザーが列を削除できるかどうかを指定します。
                    allowDeleteColumns: false,
                };

            } else {

                //元の状態に戻す
                if (this.tempCellStyleSettings != null) {
                    this.rawSpread.suspendCalcService();
                    this.rawSpread.suspendEvent();
                    this.rawSpread.suspendPaint();
                    for (var row = 0; row < this.getRowCount(); row++) {
                        for (var col = 0; col < this.getColumnCount(); col++) {
                            let colStyle = this.tempCellStyleSettings[row][col];
                            //セルに指定されていない場合はnullになっていることはありうる
                            //nullならnullで上書くことで初期化される
                            this.rawSheet.setStyle(row, col, colStyle);
                        }
                    }
                    this.rawSpread.resumePaint();
                    this.rawSpread.resumeEvent();
                    this.rawSpread.resumeCalcService();
                }

                //元の状態に戻す
                this.rawSheet.options.isProtected = this.tempProtectionOptions.isProtected;
                this.rawSheet.options.protectionOptions = _.cloneDeep(this.tempProtectionOptions.protectionOptions);
            }
        }
    }

    /**
     * エラー情報
     */
    public errorInfoList: Array<SPIRIT.interfaces.IErrorInfo>;

    /**
     * delegate
      */
    onNotifyValueChanged?: (ins: WorkSheetBase, colmunName: string, newValue: any) => void;


    /**
     * delegate
     * #5736 【保守：C】0285_SpreadJSのソート機能実行後の保存によるデータ不整合発生について
     */
    onNotifySorting?: (ins: WorkSheetBase, args: any) => void;

    /**
     * 委譲メソッド
     *  TODO　ここは改良
     */
    getRowCount(): number {
        return this.rawSheet?.getRowCount();
    }
    /**
     * 委譲メソッド
     * TODO　ここは改良
     */
    getColumnCount(): number {
        //return this.rawSheet.getColumnCount();
        return this.columns?.length;
    }
    /**
     * 委譲メソッド
     * TODO　ここは改良
     */
    getCell(i, j): Spread.Sheets.CellRange {
        return this.rawSheet.getCell(i, j);
    }


    /**
     * シート設定
     * @param sheet
     */
    protected get DefaultSheetOptions(): any {
        return {
            // 貼り付けオプションを値のみに設定
            clipBoardOptions: Spread.Sheets.ClipboardPasteOptions.values,
        };
    }

    /**
     * 
     */
    protected get DefaultSheetStyle(): Spread.Sheets.Style {
        // デフォルトスタイル設定
        const defaultStyle = new Spread.Sheets.Style();

        // セル罫線(濃すぎ！)
        //const border = new Spread.Sheets.LineBorder('#999999', Spread.Sheets.LineStyle.thin);
        const border = new Spread.Sheets.LineBorder('#00000033', Spread.Sheets.LineStyle.thin);
        defaultStyle.borderTop = border;
        defaultStyle.borderBottom = border;
        defaultStyle.borderLeft = border;
        defaultStyle.borderRight = border;

        //sheet.setDefaultStyle(defaultStyle, Spread.Sheets.SheetArea.viewport);
        //// 区分列の背景色指定
        //const colStyle = new Spread.Sheets.Style();
        //    colStyle.backColor = '#e8e8e8';
        //// スタイルを列に設定します。
        //sheet.setStyle(-1, 0, colStyle, Spread.Sheets.SheetArea.viewport);
        return defaultStyle;
    }

    /**
     * #3953
     * 正直ここに用意したくないが、基盤に載っていない○振り画面用に作成
     * ※継承していないのでstaticで宣言するため、this.DefaultSheetStyleは参照できない。
     */
    public static getDefaultSheetStyle(): Spread.Sheets.Style {
        // デフォルトスタイル設定
        const defaultStyle = new Spread.Sheets.Style();

        // セル罫線(濃すぎ！)
        //const border = new Spread.Sheets.LineBorder('#999999', Spread.Sheets.LineStyle.thin);
        const border = new Spread.Sheets.LineBorder('#00000033', Spread.Sheets.LineStyle.thin);
        defaultStyle.borderTop = border;
        defaultStyle.borderBottom = border;
        defaultStyle.borderLeft = border;
        defaultStyle.borderRight = border;

        //sheet.setDefaultStyle(defaultStyle, Spread.Sheets.SheetArea.viewport);
        //// 区分列の背景色指定
        //const colStyle = new Spread.Sheets.Style();
        //    colStyle.backColor = '#e8e8e8';
        //// スタイルを列に設定します。
        //sheet.setStyle(-1, 0, colStyle, Spread.Sheets.SheetArea.viewport);
        return defaultStyle;
    }

    /**
     *  行新規追加時用初期化変数
     */
    abstract get DefaultRowData(): {};




    /**
     * 行を新規に追加された場合に使用する
     */
    get BlankRowData(): {} {
        //空の器を用意
        let element = this.DefaultRowData;
        _.assign(element, { [WorkSheetBase.KEY_isBlank]: true })
        //変更管理列が必要か
        if (this.shouldSectionTypeColumn) {
            _.assign(element, { [WorkSheetBase.KEY_SectionType]: null });
        }
        //取込管理列が必要か
        if (this.shouldImportTypeColumn) {
            _.assign(element, { [WorkSheetBase.KEY_ImportType]: null });
        }
        return element;
    }


    /**
     * ctor
     * @param param0
     */
    constructor(spread: WorkBookBase, { sheetName, columns, dataSource, options }: { sheetName?: string; columns?: columnDef[]; dataSource?: Source; options?: {}; } = {}) {
        this.spread = spread;

        this.sheetName = sheetName || '';
        //this.sheetNo = sheetNo;
        this.columns = columns || [];
        this.source = dataSource || {};
        this.options = options || {};
        //this.mode = mode;
        this.errorInfoList = [];
    }

    /**
     *
     * @param rawdata
     */
    //createSheet() {
    //createSheet(spread?: Spread.Sheets.Workbook) {
    //createSheet(parent: WorkBookBase) {
    createSheet() {

        //this.spread = parent;

        //// 右クリック時のメニュー制御
        //this.setContextMenu(spread);

        // シート情報を取得
        //let sheet = this.spread.getSheet(this.sheetNo);
        let sheet = new Spread.Sheets.Worksheet(this.sheetName);
        //// シート名を設定
        //sheet.name(this.sheetName);
        this.rawSheet = sheet;

        // シートの設定
        this.setSheetSetting();

        this.setDefaultSheetStyle();


        //--------【動的レイアウト 横軸展開系対応】--------
        //// カラムの設定
        //this.setColSetting();
        //// ヘッダ行の設定
        //this.setHeaderRowSetting();
        //// イベントの追加
        //this.setEvents(sheet);
        //------------------------------------------------


        //sheetのtagにはデフォルトで、sheetのインスタンスが含まれているが、当オブジェクトを入れておく
        sheet.tag(this);

        return sheet;
    }


    /**
     * sourceの情報をもとにシートのデータを生成反映する
     * @param data
     */
    async load() {
        return new Promise((resolve, reject) => {
            //グリッドデータの取得
            this.loadSource(this.source).then(data => {
                this.setGridData(data);

                ////コンボボックスアイテム収集などの小さなPromiseの集合体
                //console.log(this.sheetName + ' :miscPromises : ' + this.miscPromises.length);

                //並列実行
                Promise.all(
                    this.miscPromises
                ).then((values) => {
                    //完了(成功)
                    resolve();
                }).catch((e) => {
                    //エラー
                    reject();
                }).finally(() => {
                    //削除
                    this.clearPromises();
                    // loadの終了通知
                    this.loadCompleted();
                });
            });
        });
    }


    /**
     * データを再取得しなおす
     * @param data
     */
    async reload() {

        //#1256 インポート画面表示時に親画面のエラー背景色がクリアされない
        //設定していたエラー色をクリア
        this.clearErrorInfoList();

        // レイアウト処理の無効化
        this.rawSpread.suspendPaint();
        // イベント処理の無効化
        this.rawSpread.suspendEvent();

        ////中身をしっかりと除去する
        //if (this.source.data) {
        //    //this.source.data.splice(0);
        //    this.source.data.splice(0, this.source.data.length);
        //}

        //ポインタをリセット
        this.source.data = null;

        //#948
        this.rawSheet.unbindAll(); //cancel monitoring of all events.

        //return this.load();

        //
        return new Promise((resolve, reject) => {
            this.load().then(() => {

                resolve();
            }).finally(() => {

                // イベント処理の有効化
                this.rawSpread.resumeEvent();
                // レイアウト処理の有効化
                this.rawSpread.resumePaint();
            });
        });
    }

    /**
      * データをロードする
      */
    async loadSource(source: Source): Promise<any> {

        //データの指定が無い場合で、かつURL指定がある場合
        if (!source.data && source.url) {
            //グリッドデータの取得
            //return SPIRIT.util.getData(source.url);
            // 下記だとダメ
            //return SPIRIT.util.getData(source.url).then((data) => {
            //    source.data = data;
            //});

            return new Promise((resolve, reject) => {
                SPIRIT.util.getData(source.url).then((data) => {
                    source.data = data;
                    resolve(source.data);
                });
            });

        } else {

            //未定義なら初期化して渡す
            source.data = source.data || [];
            //生のデータ設置済みの場合
            return new Promise((resolve, reject) => {
                resolve(source.data);
            });
        }
    }



    /**
     * ブランク行の追加
     * 
     * @param sourceData
     */
    protected addBlankRows(data: any[]): any[] {

        //※注　ECMAScript 2015 での新しい表記法
        data.forEach(element => _.assign(element, { [WorkSheetBase.KEY_isBlank]: false }));

        for (let i = 0; i < this.extraRowCount; i++) {
            let newData = this.DefaultRowData;
            //_.assign(newData, { 'isEdit': true })
            _.assign(newData, { [WorkSheetBase.KEY_isBlank]: true })
            data.push(newData);
        }

        return data;
    }


    /**
     * 変更管理区分列の追加
     * 
     * @param columns
     */
    protected addSectionTypeColumn(columns: columnDef[]): void {
        //if (!columns) { return; }
        columns = columns || [];
        const find = columns.findIndex(el => el.name === WorkSheetBase.KEY_SectionType);
        //見つからなかったら登録する
        if (find < 0) {
            //let SectionTypeColumn = { name: "SectionType", displayName: "区分", size: 50, visible: false };
            const SectionTypeColumn = { name: WorkSheetBase.KEY_SectionType, displayName: WorkSheetBase.KEY_SectionType_Display, size: 50, visible: true };
            columns.splice(0, 0, SectionTypeColumn);
        }
        else {
            //columns[find].visible = true;
        }
    }


    /**
     * 取込管理区分列の追加
     * 
     * @param columns
     */
    protected addImportTypeColumn(columns: columnDef[]): void {
        //if (!columns) { return; }
        columns = columns || [];
        const find = columns.findIndex(el => el.name === WorkSheetBase.KEY_ImportType);
        //見つからなかったら登録する
        if (find < 0) {
            const ImportTypeColumn = { name: WorkSheetBase.KEY_ImportType, displayName: WorkSheetBase.KEY_ImportType_Display, size: 80, visible: true };
            columns.splice(0, 0, ImportTypeColumn);
        }
        else {
            columns[find].visible = true;
        }
    }

    /**
     * 変更管理区分列の削除
     * 
     * @param columns
     */
    protected removeSectionTypeColumn(columns: columnDef[]): void {
        columns = columns || [];
        const find = columns.findIndex(el => el.name === WorkSheetBase.KEY_SectionType);
        if (find >= 0) {
            //columns[find].visible = false;//(非表示でもいいかも)
            //見つかったら削除する
            columns.splice(find, 1);
        }
    }

    /**
     * 取込管理区分列の削除
     * 
     * @param columns
     */
    protected removeImportTypeColumn(columns: columnDef[]): void {
        columns = columns || [];
        const find = columns.findIndex(el => el.name === WorkSheetBase.KEY_ImportType);
        if (find >= 0) {
            //columns[find].visible = false;//(非表示でもいいかも)
            //見つかったら削除する
            columns.splice(find, 1);
        }
    }

    /**
     * 変更管理区分項目の追加
     * 
     * @param data
     */
    protected addSectionTypeItem(data: any[]): any[] {
        //defaultで足りないものを入れる
        //data.forEach(element => _.assign(element, { 'SectionType': null }));
        data.forEach(element => _.assign(element, { [WorkSheetBase.KEY_SectionType]: null }));
        return data;
    }

    /**
     * 取込管理区分項目の追加
     * 
     * @param data
     */
    protected addImportTypeItem(data: any[]): any[] {
        //defaultで足りないものを入れる
        //data.forEach(element => _.assign(element, { 'SectionType': null }));
        data.forEach(element => _.assign(element, { [WorkSheetBase.KEY_ImportType]: null }));
        return data;
    }

    /**
    * シート設定
    * @param sheet
    */
    setSheetSetting() {
        let spreadOptions: any = {};

        let protectionOptions = null;
        //#1238
        //// 参照、インポートモードの時は編集不可
        //if (this.mode == SPIRIT.constant.GridMode.REFER) {
        //    spreadOptions.isProtected = true;
        //}

        //基本シート保護
        spreadOptions.isProtected = true;
        //
        if (this.mode == SPIRIT.constant.GridMode.REFER) {
            //Nullにしておく（フルロック）
            //protectionOptions = null;

            protectionOptions = {
                //ユーザーがロックされたセルを選択できるかどうかを指定します（オプション）。
                allowSelectLockedCells: true,
                //ユーザーがロックされていないセルを選択できるかどうかを指定します（オプション）。
                allowSelectUnlockedCells: true,
                //ユーザーが範囲をソートできるかどうかを指定します（オプション）。
                allowSort: true,
                //ユーザーが範囲をフィルタリングできるかどうかを指定します（オプション）。
                allowFilter: true,

                //ユーザーがフローティングオブジェクトを編集できるかどうかを指定します（オプション）。
                allowEditObjects: false,
                //ユーザーが行をサイズ変更できるかどうかを指定します（オプション）。
                //#2616,2617,2656 行高さ調整は基本できない。
                //折り返し設定ありのGrid（列定義にwordWrap: trueが1列でもある場合）は、行高さ調整できるで対応する
                //allowResizeRows: true,
                allowResizeRows: false,
                //ユーザーが列をサイズ変更できるかどうかを指定します（オプション）。
                allowResizeColumns: true,
                // ユーザーがドラッグ操作によって行を挿入できるかどうかを指定します。
                allowDragInsertRows: false,
                // ユーザーがドラッグ操作によって列を挿入できるかどうかを指定します。
                allowDragInsertColumns: false,
                //ユーザーが行を挿入できるかどうかを指定します。
                allowInsertRows: false,
                //ユーザーが列を挿入できるかどうかを指定します。
                allowInsertColumns: false,
                // ユーザーが行を削除できるかどうかを指定します。
                allowDeleteRows: false,
                //ユーザーが列を削除できるかどうかを指定します。
                allowDeleteColumns: false,
            }
        } else {
            protectionOptions = {
                //ユーザーがロックされたセルを選択できるかどうかを指定します（オプション）。
                allowSelectLockedCells: true,
                //ユーザーがロックされていないセルを選択できるかどうかを指定します（オプション）。
                allowSelectUnlockedCells: true,
                //ユーザーが範囲をソートできるかどうかを指定します（オプション）。
                allowSort: true,
                //ユーザーが範囲をフィルタリングできるかどうかを指定します（オプション）。
                allowFilter: true,

                //ユーザーがフローティングオブジェクトを編集できるかどうかを指定します（オプション）。
                allowEditObjects: true,
                //ユーザーが行をサイズ変更できるかどうかを指定します（オプション）。
                //#2616,2617,2656 行高さ調整は基本できない。
                //折り返し設定ありのGrid（列定義にwordWrap: trueが1列でもある場合）は、行高さ調整できるで対応する
                //allowResizeRows: true,
                allowResizeRows: false,
                //ユーザーが列をサイズ変更できるかどうかを指定します（オプション）。
                allowResizeColumns: true,
                // ユーザーがドラッグ操作によって行を挿入できるかどうかを指定します。
                allowDragInsertRows: true,
                // ユーザーがドラッグ操作によって列を挿入できるかどうかを指定します。
                allowDragInsertColumns: true,
                //ユーザーが行を挿入できるかどうかを指定します。
                allowInsertRows: true,
                //ユーザーが列を挿入できるかどうかを指定します。
                allowInsertColumns: true,
                // ユーザーが行を削除できるかどうかを指定します。
                allowDeleteRows: true,
                //ユーザーが列を削除できるかどうかを指定します。
                allowDeleteColumns: true,
            }
        }
        spreadOptions.protectionOptions = protectionOptions;

        //sheet.options = spreadOptions
        _.assign(this.rawSheet.options, this.DefaultSheetOptions, spreadOptions, this.options);


        // ヘッダの自動セットを無効化(どうする？)
        this.rawSheet.autoGenerateColumns = false;

        //#3809 初期拡大率の設定
        this.rawSheet.zoom(this.initZoomfactor);

        // 行高さが指定されている場合は設定
        if (this.defaultsRowHeight) {
            this.rawSheet.defaults.rowHeight = this.defaultsRowHeight;
        }

    }

    /**
      *
      * @param sheet
      * @param settingInfo
      */
    setDefaultSheetStyle(additional?: Spread.Sheets.Style) {
        let style = additional || new Spread.Sheets.Style();
        _.defaultsDeep(style, this.DefaultSheetStyle);
        this.rawSheet.setDefaultStyle(style, Spread.Sheets.SheetArea.viewport);
    }





    /**
     * データをグリッドに反映
     * @param data
     */
    private setGridData(data) {

        //もういらない、すでに設定済みloadSourceにて
        //this.source.data = data;
        //(data === this.source.data) => TRUE!



        //加工が必要な場合は適宜成型する！
        let _rawData = this.modelingData(this.source.data);

        //--------【動的レイアウト 横軸展開系対応】--------
        this.columns = null;
        //カラムを定義する
        this.columns = this.defineColumns(_.cloneDeep(this.source.data));

        //#2616,2617,2656 行高さ調整は基本できない。
        //折り返し設定ありのGrid（列定義にwordWrap: trueが1列でもある場合）は、行高さ調整できるで対応する
        const isExistWordWrap = this.columns.some((column) => column.style?.wordWrap === true);
        if (isExistWordWrap) {
            this.rawSheet.options.protectionOptions.allowResizeRows = true;
        }

        //新規余白が必要か
        if (this.shouldNeedExtraRow) {
            this.addBlankRows(_rawData);
        } else {
            if (this.mode == SPIRIT.constant.GridMode.EDIT) {
                _rawData.forEach(element => _.assign(element, { [WorkSheetBase.KEY_isBlank]: false }));
            }
        }

        //自分で行数をコントロールしたい場合はここで実施
        _rawData = this.modelingRows(_rawData);

        //変更管理列が必要か
        if (this.shouldSectionTypeColumn) {
            this.addSectionTypeItem(_rawData);
        }

        //取込管理列が必要か
        if (this.shouldImportTypeColumn) {
            this.addSectionTypeItem(_rawData);
        }


        //加工が必要な場合は適宜成型する！
        //加工が必要な場合は適宜成型する！（念のため取っておく）
        this.modelingColumns(this.source.data, this.columns);

        // カラムの設定
        this.setColSetting();
        // ヘッダ行の設定
        this.setHeaderRowSetting();
        //// イベントの追加←最後
        //this.setEvents(sheet);
        //-------------------------------------

        //元データを退避
        //this.rawData = _rawData;
        this.rawData = _.cloneDeep(_rawData);

        // データをセット
        //this.rawSheet.setDataSource(this.rawData);
        this.rawSheet.setDataSource(_rawData);

        // 元データを行のtagに保有しておく(最終detaSourceとして使用する)
        //②タグ保有バージョン(行タグに元データを入れて、最終画面項目で上書きする)
        this.setTagSourceItemRows();

        // グリッド行設定
        this.setContentsRowsSetting();

        // フィルタ設定
        //【SpreadJSグリッド操作】
        if (this.isNeedFilter) {
            this.setFilter();
        }

        //--------【動的レイアウト 横軸展開系対応】場所替え--------
        // イベントの追加
        this.setEvents(this.rawSheet);

        //// SetGridDataの終了通知
        //this.loadCompleted();

    }

    /**
     *  デフォルトカラム定義
     * @param sourceData --- サーバデータの生データ
     */
    abstract defineColumns(sourceData: any): columnDef[];

    /**
      * ここでrawDataにsource.dataを詰め替える！！
      * 加工が必要な場合は適宜成型する！
      * @param sourceData
      */
    protected abstract modelingData(sourceData: any): any[];

    /**
     * データ取得後、manualで、ブランク行等を追加したい場合オーバーライド
     * 加工が必要な場合は適宜成型する！（念のため取っておく）
     * @param sourceData
     * @param columns
     * @override
     */
    protected modelingRows(sourceData: any,): any[] {

        //for (let i = 0; i < 50000; i++) {
        //    let newData = this.DefaultRowData;
        //    //_.assign(newData, { 'isEdit': true })
        //    _.assign(newData, { [WorkSheetBase.KEY_isBlank]: true })
        //    sourceData.push(newData);
        //}

        return sourceData;
    }

    /**
     * データ取得後、横軸展開等が必要なレイアウトに関してはここでthis.columnnsに対して手を加える(abstractでもよかったかも)
     * 加工が必要な場合は適宜成型する！（念のため取っておく）
     * @param sourceData
     * @param columns
     * @override
     */
    protected modelingColumns(sourceData: any, columns: columnDef[]): void {
        //overridable method!
        //this.columns.push({ name: 'addedCol1' });//的な！
    }


    /**
    * Girdの列の設定
    * @param sheet
    */
    setColSetting() {
        if (this.columns && this.columns.length > 0) { }

        //変更管理列が必要か
        //if (this.isNeedSectionTypeColumn) {
        if (this.shouldSectionTypeColumn) {
            this.addSectionTypeColumn(this.columns);
        } else {
            //削除してしまう(非表示にしてもいいかも)
            this.removeSectionTypeColumn(this.columns);
        }

        //取込管理列が必要か
        if (this.shouldImportTypeColumn) {
            this.addImportTypeColumn(this.columns);
        } else {
            //削除してしまう(非表示にしてもいいかも)
            this.removeImportTypeColumn(this.columns);
        }

        // カラムをバインド
        this.rawSheet.bindColumns(this.columns);

        // 区分列の色を変更
        //if (this.isNeedSectionTypeColumn) {
        if (this.shouldSectionTypeColumn) {
            this.setSectionTypeColumnStyle(this.rawSheet);
        }

        // 取込区分列の色を変更
        if (this.shouldImportTypeColumn) {
            this.setSectionTypeColumnStyle(this.rawSheet);
        }

        for (let col = 0; col < this.columns.length; col++) {
            const column = this.columns[col];
            let colStyle = this.getColumnStyle(col);

            ////#1173　基本文字列にする
            //colStyle.formatter = '@';
            ////カスタムStyleの設定（typeがある場合はそちらが優先）
            //if (!_.isNil(column.style)) {
            //    _.assignIn(colStyle, column.style);
            //}
            //if (column.editor instanceof Spread.Sheets.Style) {
            //    colStyle = column.editor;
            //} else if (column.editor instanceof Spread.Sheets.CellTypes.Base) {
            //    colStyle.cellType = column.editor;
            //}

            //#1173 再考
            //コンボの場合はstyleでformatterの指定がない場合'General'のままにする
            //({ value: <数値(文字列以外) >、text: <文字列>}形式の場合おかしな挙動を示す)
            //GR列区分は特殊な動きをする{value:'01',text:'1'}のような　値はマッチングがあいまいなのか、コピペした段階でおかしな挙動になる
            if (column.editor instanceof Spread.Sheets.CellTypes.Base) {
                colStyle.cellType = column.editor;
            } else {
                //基本文字列にする
                colStyle.formatter = '@';
            }

            //カスタムStyleの設定（typeがある場合はそちらが優先）
            if (!_.isNil(column.style)) {
                _.assign(colStyle, column.style);
            }

            if (column.editor instanceof Spread.Sheets.Style) {
                //設定の仕方によって同一参照してしまうので、参照を切る
                //colStyle = column.editor;
                //#1516 cloneDeepでは完全に切れない（なぜ？参照？内部の管理なのか...理解しがたい）
                //builtInのclone（）ならうまくいった
                //_.assign(colStyle, _.cloneDeep(column.editor));
                _.assign(colStyle, column.editor.clone());

            } else if (column.editor instanceof ColumnEditor) {
                // #2033編集開始時日付format外の値の表示抑止
                //この場合は全て上書き
                if (column.editor.style) {
                    _.assign(colStyle, column.editor.style.clone());
                }

                if (column.editor.cellType) {
                    colStyle.cellType = column.editor.cellType;
                }
            }

            //
            this.setColumnStyle(col, colStyle);

            //// #2033編集開始時日付format外の値の表示抑止
            //// 「workSheetBase.valueChangedProcess」で抑止しようとした結果、hh:mmやMM/DDが対応出来ない為、コッチ行う
            //if (this.isDateTimePickerStyle(colStyle)) {
            //    //入力開始のインターセプター;
            //    colStyle.cellType = new DateTimeEditInterceptor(colStyle.formatter);
            //}

            // #4119 データバリデーターが設定されている場合は、データ検証をセットする
            if (column.dataFomulaOrListValidator) {
                this.setDataFomulaOrListValidator(column, col);
            }

            // ellipsis(...)を追加する処理
            this.showColumnEllipsis(col, true);

            //参照モード以外（isLockはdefaultでtrueなので、とりわけ設定する必要は無い)
            if (this.mode != SPIRIT.constant.GridMode.REFER) {
                //#1238 シート保護、セルロック方式に変更
                this.setReadonlyColumn(col, column.readonly || false);
            }

        }
    }


    /**
     * Girdのヘッダ行の設定
     * @param sheet
     */
    setHeaderRowSetting() {

        // ヘッダ行取得
        let row = this.rawSheet.getRange(0, -1, 1, -1, Spread.Sheets.SheetArea.colHeader);
        // 高さ設定
        this.rawSheet.setRowHeight(0, 40.0, Spread.Sheets.SheetArea.colHeader);

        // 背景色設定
        row.backColor("#eee");
        // 文字色設定
        row.foreColor("#444");

        //必須項目列には'＊'を表示
        if (this.columns) {
            this.columns.forEach((col, ind) => {
                if (col.required === true) {
                    //RequiredColumnHeaderCellTypeを付与
                    this.rawSheet.setCellType(0, ind, new RequiredColumnHeaderCellType(), Spread.Sheets.SheetArea.colHeader);
                }
            })
        }
    }

    /**
     * 元データを行のtagに保有しておく(最終detaSourceとして使用する)
     *②タグ保有バージョン(行タグに元データを入れて、最終画面項目で上書きする)
     * @param sheet
     */
    setTagSourceItemRows() {
        // 行数を取得
        const rowCount = this.rawSheet.getRowCount();
        for (let row = 0; row < rowCount; row++) {
            //クローンして入れる
            const element = _.cloneDeep(this.rawSheet.getDataItem(row));
            this.setOriginSourceItem(row, element);
        }
    }

    /**
     * Girdのコンテンツ行の設定
     * @param sheet
     */
    setContentsRowsSetting() {
        // 行数を取得
        const rowCount = this.rawSheet.getRowCount();
        //for (let i = 0; i < rowCount; i++) {
        //    // 行の高さの編集を不可にする
        //    sheet.setRowResizable(i, false);
        //}

        //#1258 SpreadJSのセルで改行そ含む値を入力すると、1行で繋がって表示されるので改行して表示できないか検討する
        // 行の高さの編集を不可にする
        //this.rawSheet.getRange(1, -1, rowCount, -1, Spread.Sheets.SheetArea.viewport).resizable(false);

        //WordWrap:trueのカラムが一件でもある場合
        let isExistWordWrap = this.columns.some((column) => column.style?.wordWrap === true);
        if (isExistWordWrap) {

            // #4068 spread描画時に高さ自動調整を実行するかどうか
            if (this.doAutoFit) {
                //#4309
                //for (let row = 0; row < rowCount; row++) {
                //    //自動調整（正直少しおそくなります。）
                //    this.rawSheet.autoFitRow(row);
                //}
                //高速化対応版
                this.autoFitRowForWordWrap();
            } else {
                //遅くて、ユーザーにマニュアルでやってもらう場合は下記
                this.rawSheet.getRange(0, -1, rowCount, -1, Spread.Sheets.SheetArea.viewport).resizable(true);
            }
        } else {
            //【SpreadJSグリッド操作】
            // 行の高さの編集を不可にする
            this.rawSheet.getRange(0, -1, rowCount, -1, Spread.Sheets.SheetArea.viewport).resizable(false);
        }
    }

    /**
     * 行の高さ自動調整
     * ※マニュアルで呼び出したい場合に使用
     */
    autoFitRow() {

        // 行数を取得
        const rowCount = this.rawSheet.getRowCount();

        // spread描画、イベント停止
        this.rawSpread.suspendCalcService();
        this.rawSpread.suspendEvent();
        this.rawSpread.suspendPaint();

        // 自動調整（遅い）
        for (let i = 0; i < rowCount; i++) {
            //this.rawSheet.autoFitRow(i);
            //高速化対応版
            this.autoFitRowForWordWrap(i);
        }

        // spread描画、イベント再開
        this.rawSpread.resumePaint();
        this.rawSpread.resumeEvent();
        this.rawSpread.resumeCalcService();

    }

    /**
     *
     * @param sheet
     */
    setFilter() {

        // フィルタ設定 データが全部でそろってから設定する
        //後でなくても良い(データ入れた後は再設定)
        //#2070 【不具合】行移動をすると、列フィルタが列ヘッダから外れる
        //this.filter = new Spread.Sheets.Filter.HideRowFilter(new Spread.Sheets.Range(0, -1, this.rawSheet.getRowCount(), -1));
        //-1の全カラム指定に問題があるようだが、全域だと問題ないらしい
        this.filter = new Spread.Sheets.Filter.HideRowFilter(new Spread.Sheets.Range(-1, -1, -1, -1));

        let option = {
            // sortByValueを非表示にする。
            sortByValue: true,
            // 色で並べ替え
            sortByColor: false,
            // 色フィルター
            filterByColor: true,
            // テキストフィルター
            filterByValue: true,
            // 選択肢リスト
            listFilterArea: true
        };

        _.assign(option, this.filterOptions);

        //#5736 【保守：A】0285_SpreadJSのソート機能実行後の保存によるデータ不整合発生について
        //インポート時は並び替えを一律無効とする
        if (this.mode == SPIRIT.constant.GridMode.IMPORT) {
            // sortByValueを非表示にする。
            option.sortByValue = false;
        }

        this.filter.filterDialogVisibleInfo(option);

        // フィルタ設定 データが全部でそろってから設定する(本当か？なにかいいやり方はないのか、rengeを変更するとか...)
        this.rawSheet.rowFilter(this.filter);

    }

    /**
     * DataSourcのloadを通知する
     * 見た目の成型に用いる
     * setGridDataメソッドの最後に発火する
     * 適宜オーバーライドすること
     * @override
     */
    loadCompleted() {
        //overridable method!
    }


    //1325 【不具合】行移動をし、Undoすると予期せぬ結果になる
    protected dragDropInfomation = {
        isDragDropBlock: false,
        isRowDrag: false,
        prevFromTags: [],
        prevToTags: [],
        //[DnD]            copy:false   insert : false  --              :移動 （RangeChanged  [from]+[to] 2回）
        //    from側:ds及び、Tagをブランクにする必要あり
        //    to側:dsに、Tagを_.defaultで保管（画面上に無いカラムアイテムが（fromに置いてけぼりな為））
        //「Ctrl+DnD」     copy:true    insert : false  --       :コピー  RangeChanged  [to] 1回）
        //    to側:from側のTagがコピーされてしまう（元がなくなる）Tagをもとに戻す必要あり（※DragDropBlockでTo側のRowのTagを保管しておく必要がある）
        //「Shift+DnD」     copy:false  insert : true   --      :移動挿入 (RowChanged [addRows]+[deleteRows] の2回)
        //    正常。逆になにもしてはいけない
        //「Shift+Ctrl+DnD」 copy:true  insert : true   -- :コピー挿入(RowChanged [addRows] の1回)
        //    addRowsのTagを初期化（dsをassginしたもの）元の情報もコピーされてしまう為、dsにはblankを_.defaultしたものをセット（画面項目しかコピーされない為）
        argsDnD: null
    };

    /**
    *
    * @param sheet
    */
    setEvents(sheet: Spread.Sheets.Worksheet) {


        // シート名変更時のイベント
        sheet.bind(Spread.Sheets.Events.SheetNameChanging, this, (sender, args) => {
            let _this = sender.data;
            let sheet = args.sheet;
            //【SpreadJSグリッド操作】
            // シート名変更はできないようにする
            args.cancel = true;
        });

        //#5736 【保守：C】0285_SpreadJSのソート機能実行後の保存によるデータ不整合発生について
        sheet.bind(Spread.Sheets.Events.RangeSorting, (e, args) => {
            //ソート実行通知
            this.onNotifySorting(this, args);
        });

        //セルのD&D時に呼ばれるイベント
        sheet.bind(Spread.Sheets.Events.DragDropBlock, this, (sender, args) => {
            console.log('DragDropBlock');
            let _this = sender.data;
            let sheet = args.sheet;
            let isRowDrag = (args.fromCol == -1 && args.toCol == -1);

            let prevFromTags: { row: number, tag: any }[] = [];
            let prevToTags: { row: number, tag: any }[] = [];

            //行のソレの場合
            //変更される前のTag（originSource）を保管しておく
            if (isRowDrag) {
                //From側
                for (let row = args.fromRow; row < args.rowCount + args.fromRow; row++) {
                    prevFromTags.push({ row: row, tag: _.cloneDeep(this.getTagRowItem(row)) });
                }
                //to側
                for (let row = args.toRow; row < args.rowCount + args.toRow; row++) {
                    prevToTags.push({ row: row, tag: _.cloneDeep(this.getTagRowItem(row)) });
                }
            }

            //1325 【不具合】行移動をし、Undoすると予期せぬ結果になる
            this.dragDropInfomation = {
                isDragDropBlock: true,
                isRowDrag: isRowDrag,
                argsDnD: args,
                prevFromTags: prevFromTags,
                prevToTags: prevToTags,
            }

            //section列を含む場合と横への移動は禁止(縦軸のみ移動可能)
            if ((args.fromCol == -1 || args.fromCol == args.toCol) && args.fromCol != 0) {
                args.cancel = false;
            } else {
                args.cancel = true;
            }
        });


        /** 
         *  ユーザーがセル範囲のドラッグ＆ドロップを完了したときに発生します。
         * クリップボードコピーと動きが違う...
         * クリップボードコピー ・・・ コピー対象行にTagデータがある場合、張り付けた際に「上書きしない」
         * DnDコピー            ・・・ コピー対象行にTagデータがある場合、張り付けた際に「上書きする」
         */
        sheet.bind(Spread.Sheets.Events.DragDropBlockCompleted, this, (sender, args) => {
            console.log('DragDropBlockCompleted');
            //console.log('copy:' + args.copy + '   insert : ' + args.insert);

            //[DnD]            copy:false   insert : false  --              :移動 （RangeChanged  [from]+[to] 2回）
            //    from側:ds及び、Tagをブランクにする必要あり
            //    to側:dsに、Tagを_.defaultで保管（画面上に無いカラムアイテムが（fromに置いてけぼりな為））
            //「Ctrl+DnD」     copy:true    insert : false  --       :コピー  RangeChanged  [to] 1回）
            //    to側:from側のTagがコピーされてしまう（元がなくなる、Fromの情報が一覧上重複する）Tagを元に戻す必要あり（※DragDropBlockでTo側のRowのTagを保管しておく必要がある）
            //「Shift+DnD」     copy:false  insert : true   --      :移動挿入 (RowChanged [addRows]+[deleteRows] の2回)
            //    正常。逆になにもしてはいけない
            //「Shift+Ctrl+DnD」 copy:true  insert : true   -- :コピー挿入(RowChanged [addRows] の1回)
            //    addRowsのTagを初期化（dsをassginしたもの）元の情報もコピーされてしまう為、dsにはblankを_.defaultしたものをセット（画面項目しかコピーされない為）

            let _this = sender.data;
            let sheet = args.sheet;

            //行の移動かどうか
            let isRowDrag = (args.fromCol == -1 && args.toCol == -1);
            let cellRange: { row, rowCount, col, colCount };

            //※SelectionChangeに全て任せる（DnDの場合はFrom側とTo側で計２回の「SelectionChange」が走る

            //行選択移動・コピー
            if (isRowDrag) {

                //※[DnD]  -- : 移動 （RangeChanged[from] + [to] 2回）
                //copy: false   insert: false
                if (args.copy === false && args.insert === false) {
                    ////from側:ds及び、Tagをブランクにする必要あり
                    for (let row = args.fromRow; row < args.rowCount + args.fromRow; row++) {
                        //BlankRowDataでDataSourceも更新する
                        sheet.getDataSource()[row] = this.BlankRowData;
                        //TagItemを生成し、セットする(nullなので)
                        this.setOriginSourceItem(row, this.BlankRowData);
                    }

                    //to側:dsに、Tagを_.defaultで保管（画面上に無いカラムアイテムが（fromに置いてけぼりな為））
                    for (let row = args.toRow; row < args.rowCount + args.toRow; row++) {
                        //※dsの値は最終使用しない項目なので、目をつぶる（無視。放置）（方式を策定する面倒である）
                        //productItemは担保できるので良しとする
                        //_.defaultsDeep(sheet.getDataSource()[row], this.BlankRowData);//取得時の値を保持
                    }
                }

                //※「Ctrl+DnD」--       : コピー  RangeChanged[to] 1回）
                //copy: true    insert: false  
                if (args.copy === true && args.insert === false) {
                    //to側:from側のTagがコピーされてしまう（元がなくなる、Fromの情報が一覧上重複する）Tagを元に戻す必要あり（※DragDropBlockでTo側のRowのTagを保管しておく必要がある）
                    for (let row = args.toRow; row < args.rowCount + args.toRow; row++) {
                        //移動前の情報から抽出
                        var prev = this.dragDropInfomation.prevToTags.find(v => { return v.row === row; });
                        //※移動元のTagとコピーされたTagで同一参照な為、参照を切る必要がある為、Tagの中身をごっそり入れ替える
                        this.setTagRowItem(row, prev?.tag);
                    }
                }

                //※「Shift+DnD」--      : 移動挿入(RowChanged[addRows] + [deleteRows] の2回)
                //copy: false  insert: true   
                if (args.copy === false && args.insert === true) {
                    //正常。逆になにもしてはいけない
                    //noop
                }

                //※「Shift+Ctrl+DnD」-- :コピー挿入(RowChanged [addRows] の1回)
                //copy: true  insert: true   
                if (args.copy === true && args.insert === true) {
                    // toのTagを初期化（dsをassginしたもの）元の情報もコピーされてしまう為、dsにはblankを_.defaultしたものをセット（画面項目しかコピーされない為）
                    for (let row = args.toRow; row < args.rowCount + args.toRow; row++) {
                        _.defaultsDeep(sheet.getDataSource()[row], this.BlankRowData);//取得時の値を保持
                        //TagItemを生成し、セットする(nullなので)
                        this.setOriginSourceItem(row, this.BlankRowData);
                    }
                }

                cellRange = {
                    row: args.toRow,
                    rowCount: args.rowCount,
                    col: 0,
                    colCount: this.columns.length,
                }
                //変更確定通知
                this.valueChangedRange(cellRange, '');

            } else {
                //セル値の移動
                //この判断は特に必要無い
                //CtrKey押下状態で値コピー
                //if (args.copy) {
                //} else {
                //}
                //debugger;
                cellRange = {
                    row: args.toRow,
                    rowCount: args.rowCount,
                    col: args.toCol,
                    colCount: args.colCount,
                }
                this.valueChangedRange(cellRange, '');
            }


            //1325 【不具合】行移動をし、Undoすると予期せぬ結果になる
            this.dragDropInfomation = {
                isDragDropBlock: false,
                isRowDrag: false,
                argsDnD: null,
                prevFromTags: null,
                prevToTags: null
            }
            //
            //this.valueChangedRange(cellRange, '');
        });




        //******************Clipboard******************
        //クリップボード貼り付け時のイベント
        sheet.bind(Spread.Sheets.Events.ClipboardPasting, this, (sender, args) => {
            console.log('ClipboardPasting');
            let _this = sender.data;
            let sheet = args.sheet;

            //領域以上(columnn)のデータを張り付けようとした場合無効
            //visibleなくすつもりです
            const visColCount = this.columns.filter(s => !(s.visible === false)).length;
            //const visColCount = this.columns.length;

            //貼り付け対象の最大列インデックス
            const tryPasteMaxColIndex = args.cellRange.col + args.cellRange.colCount;
            if (tryPasteMaxColIndex > visColCount) {

                //「allowExtendPasteRange: false」な場合必要ない処理（発生しないだろう）
                //[SpreadJSのシートレベルバインディング時に、行をコピー後「コピーしたセルを挿入」を行ったところ、値が挿入されません。]
                //の問い合わせの回答結果でallowExtendPasteRange: trueとなったようだ。現状「コピーしたセルを挿入」自体使用しないので、allowExtendPasteRange: trueでも良いかも(動作に問題は無かった)
                let msg = 'コピー領域と貼り付け領域のサイズが違うため、これをここに張り付けることができません。'
                //msg += '貼り付け領域内のいづれか１つのセルを選ぶか、または同じサイズの領域を選び、もう一度張り付けてください。'
                SPIRIT.notify.warn(msg, { position: 'bottom right' });
                args.cancel = true;
                return;
            }

            // 列全体のコピーペーストを無効化
            if (args.cellRange.row == -1 && args.cellRange.rowCount == -1) {
                args.cancel = true;
                return;
            }

            // 「区分」列だけのコピペは禁止
            if (args.cellRange.colCount === 1) {
                let coldef = this.getColumnDef(args.cellRange.col);
                if (coldef.name === WorkSheetBase.KEY_SectionType || coldef.name === WorkSheetBase.KEY_ImportType) {
                    args.cancel = true;
                    return;
                }
            }
        });

        // クリップボード貼り付け時のイベント
        sheet.bind(Spread.Sheets.Events.ClipboardPasted, this, (sender, args) => {
            console.log('ClipboardPasted');
            let _this = sender.data;
            let sheet = args.sheet;
            let range: { row, rowCount, col, colCount };

            //※SelectionChangeに全て任せる

            ////行コピー
            //if (args.cellRange.col == -1 && args.cellRange.colCount == -1) {
            //    //※下記はあえてやらない。既存行へのコピーをした場合が少し問題...
            //    //コピー元の行を「既存行」に張り付けた段階で、
            //    //「新規」行ととらえるか、はたまた、単純に値の上書き「変更」ととらえるかである
            //    //ここは「更新」と捉えて、Tag（元データ）はそのままにしておく...
            //    //※DnDコピーを動きが違います。
            //    //ここは保険　RangeChangeに移動
            //    ////【SpreadJSグリッド操作】
            //    //for (let row = args.cellRange.row; row < args.cellRange.rowCount + args.cellRange.row; row++) {
            //    //    //console.log(this.getOriginSourceItem(row));
            //    //    //シートの最終行等で自動追加された行はTagにDataが存在しないのでデータが無い場合は初期データを入れる
            //    //    if (_.isNil(this.getOriginSourceItem(row))) {
            //    //        ////isBlankがそれに相当するみたい、なのでBlankRowDataでDataSourceも更新する
            //    //        //sheet.getDataSource()[row] = this.BlankRowData;
            //    //        ////TagItemを生成し、セットする(nullなので)
            //    //        //this.setTagSourceItem(row, this.BlankRowData);
            //    //        //他とは違う点としては、この段階としてDataSourceには値がペーストしたデータが既に入っている
            //    //        //よって足りない項目を追加しなおす
            //    //        _.defaultsDeep(sheet.getDataSource()[row], this.BlankRowData);//取得時の値を保持
            //    //        //TagItemを生成し、セットする(nullなので)
            //    //        this.setOriginSourceItem(row, this.BlankRowData);
            //    //        //今現在の値を、直近のデータとする
            //    //        this.savePreviewSourceItem(row);
            //    //    }
            //    //}
            //    range = {
            //        row: args.cellRange.row,
            //        rowCount: args.cellRange.rowCount,
            //        col: 0,
            //        colCount: this.columns.length,
            //    }
            //} else {
            //    //範囲コピー
            //    //for (let row = args.cellRange.row; row < args.cellRange.row + args.cellRange.rowCount; row++) {
            //    //    //let rowData = sheet.getDataItem(i);
            //    //    //イベント発火
            //    //    //_this.valueChanged(_this, args.row, args.col, args.pasteData.text);
            //    //    //_this.valueChanged(args.row, args.col, args.pasteData.text);
            //    //    for (let col = args.cellRange.col; col < args.cellRange.col + args.cellRange.colCount; col++) {
            //    //        //TODO pasteDataも展開すべきかも！
            //    //        _this.valueChanged(row, col, args.pasteData.text);
            //    //    }
            //    //}

            //    range = args.cellRange;
            //}

            //this.valueChangedRange(range, args.pasteData.text);
        });




        //******************Editing******************
        // 「区分」の場合入力させないようにする
        sheet.bind(Spread.Sheets.Events.EditStarting, this, (sender, args) => {
            console.log("EditStarting ------ ");

            //SectionTypeはイベントキャンセル
            //if (args.col == 0) {
            let col = this.getColumnDef(args.col);
            if (col.name === WorkSheetBase.KEY_SectionType || col.name === WorkSheetBase.KEY_ImportType) {
                args.cancel = true;
                //} else {
                //    this.editingValue = args.sheet.getValue(args.row, args.col);
            }

            //#1238 シート保護、セルロック方式に変更
            //【独自readonly(ロック)方式】
            ////readonlyはキャンセル
            //if (col.readonly) {
            //    args.cancel = true;
            //}


        });

        // 値変更時のイベント
        sheet.bind(Spread.Sheets.Events.ValueChanged, this, (sender, args) => {

            console.log('ValueChanged');
            //SectionTypeは変更管理しない
            let col = this.getColumnDef(args.col);
            if (col.name === WorkSheetBase.KEY_SectionType || col.name === WorkSheetBase.KEY_ImportType) { return; }
            // 入力値が入力前のものと異なる場合「変更」、「追加」の文言を追加
            if (args.newValue != args.oldValue) {

                //値変更処理
                this.valueChanged(args.row, args.col, args.newValue);
            }
        });


        //******************RangeChange******************
        // deleteキー押下時のイベント
        sheet.bind(Spread.Sheets.Events.RangeChanged, this, (sender, args) => {

            var getAction = function () {
                if (args.action == Spread.Sheets.RangeChangedAction.dragDrop) {
                    return 'dragDrop';
                } else if (args.action == Spread.Sheets.RangeChangedAction.dragFill) {
                    return 'dragFill';
                } else if (args.action == Spread.Sheets.RangeChangedAction.clear) {
                    return 'clear';
                } else if (args.action == Spread.Sheets.RangeChangedAction.paste) {
                    return 'paste';
                } else if (args.action == Spread.Sheets.RangeChangedAction.sort) {
                    return 'sort';
                } else if (args.action == Spread.Sheets.RangeChangedAction.setArrayFormula) {
                    return 'setArrayFormula';
                } else if (args.action == Spread.Sheets.RangeChangedAction.evaluateFormula) {
                    return 'evaluateFormula';
                } else {
                    return '';
                }
            }

            console.log('RangeChanged --' + getAction() + ':' + args.row);

            let _this = sender.data;
            let sheet = args.sheet;

            let cellRange: { row, rowCount, col, colCount };
            cellRange = {
                row: args.row,
                rowCount: args.rowCount,
                col: args.col,
                colCount: args.colCount,
            }


            // deleteキーが押下されたときのイベント
            if (args.action == Spread.Sheets.RangeChangedAction.clear) {
                //値変更処理  
                this.valueChangedRange(cellRange, '');
            }

            // pasteされたときキーが押下されたときのイベント
            if (args.action == Spread.Sheets.RangeChangedAction.paste) {

                //「ClipboardPasted」でも同じことをしているが、コッチが先に入る
                //行コピー
                //if (args.col == -1 && args.colCount == -1) {
                //「ClipboardPasted」でも同じことをしているが、コッチが先に入る
                for (let row = args.row; row < args.rowCount + args.row; row++) {
                    //単純なDnDだけの移動とshift+DnDでは切り分ける為値が存在しない!!
                    //shift+DnDでは、移動では無く「入れ替え」。その場合tagのsourceも残っているので、ここで入れてしまうと飛んでしまう。

                    //TagにDataが存在しないを時を単純なDnD移動とみなし初期化する
                    if (_.isNil(this.getOriginSourceItem(row))) {
                        //他とは違う点としては、この段階としてDataSourceには値がペーストしたデータが既に入っている
                        //よって足りない項目を追加しなおす
                        _.defaultsDeep(sheet.getDataSource()[row], this.BlankRowData);//取得時の値を保持
                        //新規行なので、既に入っているdataSourceとの差異を出すためにOriginはBlankとする
                        this.setOriginSourceItem(row, this.BlankRowData);


                        //※↓をここに入れると、readonlyなセルに対して、直近の値が入る為、コピー出来たように見えてしまう
                        //対象のreadonlyセルの内容にもよると思うが、コピー出来たほうが良いケースもある気がする
                        //現状はコメントアウト
                        ////今現在の値を、直近のデータとする
                        //this.savePreviewSourceItem(row);


                    }
                }
                //値変更処理  
                this.valueChangedRange(cellRange, '');
                //}
            }

            //DropBlockComplateで行う
            //// dragDropされたときキーが押下されたときのイベント
            //if (args.action == Spread.Sheets.RangeChangedAction.dragDrop) {
            //    //if (args.col == -1 && args.colCount == -1) {
            //    //「ClipboardPasted」でも同じことをしているが、コッチが先に入る
            //    for (let row = args.row; row < args.rowCount + args.row; row++) {
            //        //TagにDataが存在しないを時を単純なDnD移動とみなし初期化する
            //        if (_.isNil(this.getOriginSourceItem(row))) {
            //            //他とは違う点としては、この段階としてDataSourceには値がペーストしたデータが既に入っている
            //            //よって足りない項目を追加しなおす
            //            _.defaultsDeep(sheet.getDataSource()[row], this.BlankRowData);//取得時の値を保持
            //            //新規行なので、既に入っているdataSourceとの差異を出すためにOriginはBlankとする
            //            this.setOriginSourceItem(row, this.BlankRowData);
            //        }
            //    }
            //    //値変更処理  
            //    this.valueChangedRange(cellRange, '');
            //    //}
            //}


            //UndoRedo
            if (args.isUndo) {
                //この場合はおもにステータスをもとに戻す
                //値変更処理（）
                this.valueChangedRange(cellRange, '');
            }

        });


        //******************RowChanged******************

        //行追加、行削除、Tagのセットなど
        sheet.bind(Spread.Sheets.Events.RowChanged, this, (sender, args) => {
            console.log("RowChanged ------ " + args.propertyName);
            //console.log('args.row　:　' + args.row);


            let _this = sender.data;
            let sheet = args.sheet;

            //行追加の場合
            if (args.propertyName === 'addRows') {
                // 下記の以外にも、複数行選択からの移動にて、もともとあった行のTAGがundefinedになる。

                ////console.log(this.getTagSourceItem(args.row))
                ////この場合は、spreadが用意したDataItemをもとにTagItemを生成し、セットする(nullなので)
                //    this.setTagSourceItem(args.row, _.cloneDeep(sheet.getDataItem(args.row)));
                //spreadにバグがある。
                //「最終列の値がFalseの場合、コピーしたセルのシフト挿入動作が不正になる」
                //https://dev.grapecity.co.jp/support/kb/detail.asp?id=86287
                ////isBlankがそれに相当するみたい、なのでBlankRowDataでDataSourceも更新する

                //Shift+DnDでの場合、恐らくspreadが内部処理として新規行を追加している様である
                //とくに、不必要そうだし、入れない方が良さそうなので、入れない

                //Undo以外で単純な行追加のみ空データを作成する
                if (!this.dragDropInfomation.isDragDropBlock && !args.isUndo) {

                    //複数行対応
                    for (let row = args.row; row < args.row + args.count; row++) {
                        //isBlankがそれに相当するみたい、なのでBlankRowDataでDataSourceも更新する
                        sheet.getDataSource()[row] = this.BlankRowData;
                        //TagItemを生成し、セットする(nullなので)
                        this.setOriginSourceItem(row, this.BlankRowData);
                        //行を追加しただけで、変更とみなすか否か
                        //値変更処理
                        this.valueChanged(row, -1, null);
                    }
                }
            }

            //1266
            if (args.propertyName === 'deleteRows') {
                //#2071 
                //恐らくspreadjsがUnDoの場合は、全行に影響が加わるらしい、よってargs.countが行数になる
                //その為、args.row() + args.countではオーバーフローを起こす、その際に例外が発生している様である
                //addRows同様、Shift+DnDでの場合、恐らくspreadが内部処理として新規行を追加している様である
                //とくに、不必要そうだし、入れない方が良さそうなので、入れない
                //Undo以外で単純な行追加のみ空データを作成する
                if (!args.isUndo) {
                    //行数の補正
                    let count = args.count;
                    let cellRange = {
                        row: args.row,
                        rowCount: count,
                        col: -1,
                        colCount: 0,
                    }
                    this.valueChangedRange(cellRange, '');
                }
            }

            if (args.propertyName === 'tag') {
                //console.log('tag', this.getTagSourceItem(args.row));
            }

        });


        //TAGデバッグ用
        //sheet.bind(Spread.Sheets.Events.CellClick, (sender, args) => {
        //    let selections = sheet.getSelections();
        //    let sel = selections[0], row = sel.row;
        //    //console.log('[debug] ' + sel.row + ' ---------------------------------------')
        //    //console.log('origin : ', this.getOriginSourceItem(row));
        //    //console.log('preveiw : ', this.getPreviewSourceItem(row));
        //    //console.log('raw : ', this.rawSheet.getDataItem(row));
        //    //console.log('product : ', this.getDataItem(row));
        //    if (args.sheetArea === Spread.Sheets.SheetArea.rowHeader) {
        //        console.log('[debug CellClick] ' + args.row + ' ---------------------------------------')
        //        console.log('origin : ', this.getOriginSourceItem(row));
        //        console.log('raw : ', this.rawSheet.getDataItem(row));
        //        console.log('product : ', this.getDataItem(row));
        //    }
        //});

    }


    /**
     * 
     * @param row
     * @param col
     * @param immediate　現在は機能しません
     */
    private valueChangedProcess(row: number, col: number, immediate?: boolean) {

        let column = this.getColumnDef(col);

        if (!column) { return; }
        //getDataItemで取得すると、getDataSourceとの参照切れるみたいなので、再度セットする必要がある
        //let rowData = this.rawSheet.getDataItem(row);
        //let rowData = this.rawSheet.getDataSource()[row];
        //let originData = this.getOriginSourceItem(row);


        //#1238 シート保護、セルロック方式に変更
        //【独自readonly(ロック)方式】
        //let previewData = this.getPreviewSourceItem(row);
        //if (!previewData) {
        //    //前回履歴が無い場合、初期データを前回履歴とする
        //    previewData = _.cloneDeep(this.getOriginSourceItem(row));
        //}

        //編集タイプによる個別の処理
        if (column.editor instanceof Spread.Sheets.Style) {
            //null;

            //下記一旦ペンディング

            //var colStyle  = this.getColumnStyle(col, this.rawSheet);
            ////現在表示（入力）されたValueを取得
            //let value = this.rawSheet.getValue(row, col);
            ////現在表示（入力）されたTextを取得
            //let text = this.rawSheet.getText(row, col);
            ////日付
            //if (colStyle.formatter === "yyyy/MM/dd") {
            //    //日付コントロールは数値を直接入力されると、それなりに解釈してしまうことがある
            //    //一度'あ'などの文字を入力したあと、数値を入れると本来はDate型が入る'value'に数値、'Text'に日付がはいってしまうため
            //    //再度入力しようとした際に、一旦数値が表示されてしまう（リクエストする際にもおかしくなりそう）
            //    if (_.isSafeInteger(value)) {
            //        this.rawSpread.suspendEvent();
            //        ////なので、Value値をDateにキャストしてしまう
            //        //    this.rawSheet.setValue(row, col, new Date(value));//これだと/OADate形式にならない（spreadが内部で,net用の日付形式に変換してるっぽい）
            //        //なので、Text値をいれてしまう（その後勝手に）
            //        this.rawSheet.setValue(row, col, text);
            //        this.rawSpread.resumeEvent();
            //    }
            //}


        } else if (column.editor instanceof Spread.Sheets.CellTypes.Base) {
            //廃止!!最後（当オブジェクトのgetDataSourceで帳尻を合わせる）
            ////※過剰実装？最終保存前に実施すればよいかも!!
            ////関連項目のDataSource反映
            //this.applyRelatedTextTarget(rowData, row, col);
        }

        //#2033 でコミット仕様とした、本来の恒久対応(hh:mmやMM/DDが対応出来ない為却下)
        //if (this.isDateTimeCell(row, col)) {
        //    //現在表示（入力）されたValueを取得
        //    let value = this.rawSheet.getValue(row, col);
        //    let OADatevalue = this.rawSheet.getDataItem(row)[column.name];//OAData形式文字列(データソースには先で入っている)
        //    //現在表示（入力）されたTextを取得
        //    let text = this.rawSheet.getText(row, col);
        //    //日付コントロールは数値を直接入力されると、それなりに解釈してしまうことがある
        //    //一度'あ'などの文字を入力したあと、数値を入れると本来はDate型が入る'value'に数値、'Text'に日付がはいってしまうため
        //    //再度入力しようとした際に、一旦数値が表示されてしまう（リクエストする際にもおかしくなりそう）
        //    if (SPIRIT.util.date.isDate(text)) {
        //        this.rawSpread.suspendEvent();
        //        //なので、Value値をDateにキャストしてしまう
        //        this.rawSheet.setValue(row, col, new Date(text));//これだと/OADate形式にならない（spreadが内部で,net用の日付形式に変換してるっぽい）
        //        this.rawSpread.resumeEvent();
        //    }
        //}


        //#1258
        //WordWrap:trueのカラムの場合
        if (column.style?.wordWrap === true) {
            //自動調整
            //#4309
            //this.rawSheet.autoFitRow(row);
            //高速化対応版
            this.autoFitRowForWordWrap(row);
        }

        //#1238 シート保護、セルロック方式に変更
        //【独自readonly(ロック)方式】
        ////readonly（消さないは出来ないので、一旦受け入れて元に戻す）
        ////一旦消えるが疑似的に戻す
        //if (!immediate) {
        //    if (column.readonly) {
        //        if (previewData) {
        //            //値を戻し、変更されなかったこととする
        //            var prevVal = previewData[column.name] || null;
        //            this.rawSheet.setValue(row, col, prevVal);
        //        }
        //    }
        //}

    }

    /**
 * 
 * @param sender
 * @param args
 */
    protected updateSectionTypeColumn(row: number) {

        // 変更管理列がある場合
        if (this.shouldSectionTypeColumn) {

            //※なぜだか下の旧式の区分名称設定ロジックだと、UndoRedoで反応しないが、
            //その下の、ロジックだと、うまいこと動く...（なぜか理解できない）

            ////let rowData = this.rawSheet.getDataSource()[row];
            //let rowData = this.getTagSourceItem(row);
            ////isBlankの定義が存在しない(spreadのオペレーション当で自動で追加された行など)
            //if (_.isNil(rowData[WorkSheetBase.KEY_isBlank]) || rowData[WorkSheetBase.KEY_isBlank]) {
            //    //this.rawSheet.setText(row, 0, SPIRIT.codes.SectionType.ADDED.value);
            //    this.rawSheet.setValue(row, 0, SPIRIT.codes.SectionType.ADDED.value);
            //} else {
            //    //this.rawSheet.setText(row, 0, SPIRIT.codes.SectionType.EDITED.value);
            //    this.rawSheet.setValue(row, 0, SPIRIT.codes.SectionType.EDITED.value);
            //}

            //タグ上の元データとsheetのRawを比較する
            let isRowEdited = this.checkRowEdited(row);
            let rowData = this.getOriginSourceItem(row);

            //#2071 問題はここ、恐らくundo処理中で
            //NULLだと落ちるので返す
            if (!rowData) { return null; }

            let col = this.getColumnIndex(WorkSheetBase.KEY_SectionType);
            if (isRowEdited) {
                //isBlankの定義が存在しない(spreadのオペレーション当で自動で追加された行など)
                if (_.isNil(rowData[WorkSheetBase.KEY_isBlank]) || rowData[WorkSheetBase.KEY_isBlank]) {
                    //this.rawSheet.setText(row, 0, SPIRIT.codes.SectionType.ADDED.value);
                    this.rawSheet.setValue(row, col, SPIRIT.codes.SectionType.ADDED.value);
                } else {
                    //this.rawSheet.setText(row, 0, SPIRIT.codes.SectionType.EDITED.value);
                    this.rawSheet.setValue(row, col, SPIRIT.codes.SectionType.EDITED.value);
                }
            } else {
                //変更がない場合
                //リセット
                //this.rawSheet.setValue(row, col, SPIRIT.codes.SectionType.NONE.value);
                this.rawSheet.setValue(row, col, null);
            }
        }
    }

    /**
     * 対象行に変更が加わっているか判断する
     * @param row
     */
    protected checkRowEdited(row: number): boolean {

        //タグ上の元データとsheetのRawを比較する
        let tagData = this.getOriginSourceItem(row);
        let rowData = this.rawSheet.getDataItem(row);

        //編集行為が行われるのは、column定義されているもののみで比較
        //名前のみ取得
        let def = _.map(this.columns, 'name');
        //変更区分列がある場合は除去する
        _.remove(def, (n) => n === WorkSheetBase.KEY_SectionType);

        //対象抽出
        let src = _.pick(tagData, def);
        let dst = _.pick(rowData, def);


        //日付項目が入っていると正常に動作しない
        //理由：型の違い
        //元データはDateオブジェクト（途中で文字列からキャストしている）
        //spread上のDatasourceに入っているそれはOADate（microsoft関連の形式）と言われる独特な文字列形式。キャストが出来ない（方法はあるようだが、独特）
        //追記:moment.jsなら出来るかもfullcalendarでの使用も検討してるから後で見直す
        //srcの項目の内容が日付の場合,dstも日付に変換し比較する、文字列にして比較
        _.forIn(src, (value, key) => {
            if (_.isDate(value)) {
                //src[key] = value.toISOString();
                src[key] = value.toLocaleString();//ミリ秒は切り捨て
                if (_.has(dst, key)) {
                    //日付ならそのまま採用し
                    if (_.isDate(dst[key])) {
                        //dst[key] = dst[key].toISOString();
                        dst[key] = dst[key].toLocaleString();//ミリ秒は切り捨て
                    } else {
                        //AODate型なのでキャストが出来ない(moment.jsなら...)
                        //if (dst[key]) {
                        //    dst[key] = new Date(dst[key]);
                        //}
                        //日付で無い場合は
                        //画面のテキストから取得
                        let colidx = _.findIndex(this.columns, (o) => o.name === key);
                        if (colidx > -1) {
                            let text = this.rawSheet.getText(row, colidx);
                            //dst[key] = (new Date(text)).toISOString();
                            dst[key] = (new Date(text)).toLocaleString();//ミリ秒は切り捨て
                        }
                    }
                }
            }
        });
        //タグ上の元データとsheetのRawを比較する
        //変更差分があれば変更
        //let isEdited = !_.eq(src, dst);//instancy

        //var dif = _.omitBy(src, (v, k) => dst[k] === v);
        //let isEdited = !_.isEmpty(dif);
        //var dif1 = _.omitBy(dst, (v, k) => src[k] === v);
        //console.log(dif);
        //console.log(dif1);

        //.isEqualたまにうまく動かない?（まったく同じなのに...）
        let isEdited = !_.isEqual(src, dst);
        return isEdited;
    }

    /**
     * 
     * @param row
     * @param col
     * @param value
     * @param immediate 現在は機能しません
     */
    protected valueChanged(row: number, col: number, value, immediate?: boolean) {

        try {
            //内部的にValueを変更してしまうため。SpreadのイベントvalueChangedが走ってしまうため、イベントのsuspendを行う
            this.rawSpread.suspendEvent();
            //DisplayNameがとれる?なんかおかしい
            //let displayName = sheet.getDataColumnName(col);
            //let columnName = _this.columns.find(col => col.displayName === displayName).name;

            //colが-1の場合もある(行削除)
            let column = this.getColumnDef(col);
            let columnName = column?.name || null;

            //保険
            this.valueChangedProcess(row, col, immediate);

            //#1238 シート保護、セルロック方式に変更
            //なので必要では無いが、一旦残しておく
            this.savePreviewSourceItem(row);

            //更新区分の更新
            this.updateSectionTypeColumn(row);

            //イベント発火
            this.fireValueChange(this, row, col, columnName, value);

        } catch (e) {
            console.log(e);
        } finally {
            //イベントハンドルの再開
            this.rawSpread.resumeEvent();
        }
    }


    /**
     * 
     * @param cellRange
     * @param value
     * @param immediate　現在は機能しません
     */
    protected valueChangedRange(cellRange, value: any, immediate?: boolean) {
        try {

            //内部的にValueを変更してしまうため。SpreadのイベントvalueChangedが走ってしまうため、イベントのsuspendを行う
            this.rawSpread.suspendEvent();
            //
            for (let row = cellRange.row; row < cellRange.row + cellRange.rowCount; row++) {
                for (let col = cellRange.col; col < cellRange.col + cellRange.colCount; col++) {
                    //保険
                    this.valueChangedProcess(row, col, immediate);
                }

                //#1238 シート保護、セルロック方式に変更
                //なので必要では無いが、一旦残しておく
                this.savePreviewSourceItem(row);

                //更新区分の更新
                this.updateSectionTypeColumn(row);
            }

            //イベント発火(先頭)
            this.fireValueChange(this, cellRange.row, cellRange.col, '', value);

        } catch (e) {
            console.log(e);
        } finally {
            //イベントハンドルの再開
            this.rawSpread.resumeEvent();
        }
    }

    /**
     * 
     * @param sender
     * @param args
     */
    protected fireValueChange(sheet: WorkSheetBase, row, col, columnName?, value?) {
        //this.onValueChange(_this, name, value);
        this.onNotifyValueChanged.call(sheet, sheet, columnName, value);
    }

    /**
     * 行データ取得 (※削除予定)
     * shorts cut of getProductItem
     * @param row
     * @deprecated
     */
    public getDataItem(row: number): any {
        return this.getProductItem(row);
    }

    /**
     * データ取得 (※削除予定)
     * shorts cut of getProductSource
     * (※削除予定)
     * @deprecated
     */
    public getDataSource(): any[] {
        return this.getProductData();
    }
    /**
     * 正規データの取得
     * @param row
     */
    public getProductItem(row: number): any {

        //①非表示列バージョン(都度新しいItemを生成して作り出す)
        ////空の器を用意
        //let element = this.DefaultRowData;
        ////_.assign(newData, { [WorkSheetBase.KEY_isBlank]: true })

        ////変更管理列が必要か
        //if (this.shouldSectionTypeColumn) {
        //    _.assign(element, { [WorkSheetBase.KEY_SectionType]: null });
        //}
        ////取込管理列が必要か
        //if (this.shouldImportTypeColumn) {
        //    _.assign(element, { [WorkSheetBase.KEY_ImportType]: null });
        //}

        //②タグ保有バージョン(行タグに元データを入れて、最終画面項目で上書きする)
        //tag上のデータを取得(この場合tagのデータが変わらないようにCloneする)
        let element = _.cloneDeep(this.getOriginSourceItem(row));

        //NULLだと落ちるので返す
        if (!element) { return null; }

        //relatedTextTargetに登録されているKey名を退避
        //（このカラムの定義がある場合、初回表示時の値が設定されていて、画面状態による最新の情報でないことがある
        //(恐らくリクエスト用のプロパティであるケースが多い)
        //よって画面の値ではなくrelatedTextTarget指定がある項目（現状、概ねcombobox）のcell.text項目を設定してelementとする
        //仮にcolumnの定義にあっても、無くても、上記のrelatedTextTarget指定がある項目のrelatedTextTargetの名称でプロパティを生成する
        let relatedTextTargetNames = _.map(this.columns, 'relatedTextTarget')
        relatedTextTargetNames = _.reject(relatedTextTargetNames, function (o) { return _.isNil(o); });
        //定義上存在しないようなら、追加する
        //relatedTextTargetNames.forEach(r => { _.assign(element, { [r]: null }); });//取得時の値をリセット
        relatedTextTargetNames.forEach(r => { _.defaults(element, { [r]: null }); });//取得時の値を保持


        let colCount = this.getColumnCount()
        //要するにカラム定義したItemしか更新しない！！
        for (let col = 0; col < colCount; col++) {
            let column = this.columns[col];
            let columnName = column.name;

            //relatedTextTargetNames内に存在している、実カラムはスキップ
            if (relatedTextTargetNames.includes(columnName)) { continue; }
            //現在表示（入力）されたValueを取得
            let value = this.rawSheet.getValue(row, col);
            //現在表示（入力）されたTextを取得
            let text = this.rawSheet.getText(row, col);


            //コンボボックスエディタの振る舞い方
            /**重要**** */
            //編集可能で、Spread.Sheets.CellTypes.EditorValueType.valueのコンボボックスは、選択リストに存在しない値を入力した際、
            //cell.value及びDatasource(DataItem)に入力した値が登録されてしまう。（cell.textにも入ります！こっちは見た目上の値なので、取っておく）
            //その為、relatedTargetに入力した値を退避(サーバーリクエスト用)

            //**警告!! コンボ　ペースト時の**** */
            //column.editor.editable(編集可能)なコンボと、そうでない場合の動作が違う！！！！！！」
            //編集可能なコンボの場合、値の貼り付けなどで、選択リストに入っているvalue、Textでマッチしていれば（どちらでも可）
            //例：「value: 660, text: 'AAA'」の場合、どっちの値を張り付けても、value:660となり良い感じになる
            //--------
            //対してcolumn.editor.editable()　==false （編集不可）の場合、張り付けた値がそのままValueとなる
            //例：「value: 660, text: 'AAA'」の場合、AAAを張り付けた場合、value:AAAとなる


            //**（警告）ペースト時の通常の問題**** */
            //'04'など前ゼロ文字列をペーストすると、4（数値）に勝手に変換されてしまう（恐らく書式の問題だろう!!）


            if (column.editor instanceof Spread.Sheets.CellTypes.ComboBox && column.editor.editorValueType() === Spread.Sheets.CellTypes.EditorValueType.value) {

                //リクエストする様の値を退避
                if (column.relatedTextTarget && column.relatedTextTarget in element) {
                    //関連プロパティがある場合はコンボボックスのText値を直接データソースそのアイテムに設定する
                    element[column.relatedTextTarget] = text;
                }

                //if (column.editor.editable()) {


                //value値が選択リストにあるか判定
                //spreadJsのコンボはeditable=trueの場合、候補リスト内に存在しないものが入ると、入力値がどちらにも入ってしまう！！

                //※ブラウザでのDebug可視性の向上
                //let cmbItems = <{ text, value }[]>column.editor.items();
                let cmbItems = column.editor.items() as { text, value }[];

                if (cmbItems.findIndex(item => item.value === value) === -1) {

                    ////不用意に入ってしまったcell.value及びDatasource(DataItem)の値は登録しない
                    //element[columnName] = null;

                    //#1173 再考
                    //コンボの場合はstyleでformatterの指定がない場合'General'のままにする
                    //({ value: <数値(文字列以外) >、text: <文字列>}形式の場合おかしな挙動を示す)
                    //GR列区分は特殊な動きをする{value:'01',text:'1'}のような　値はマッチングがあいまいなのか、コピペした段階でおかしな共同になる
                    var namedBy = cmbItems.find(item => item.text === text);
                    //valueで当たらない場合、名称で当てて取得できるかテストする
                    if (namedBy) {
                        //名称でヒットしたらそのvalueを入れる
                        element[columnName] = namedBy.value;
                    } else {
                        //不用意に入ってしまったcell.value及びDatasource(DataItem)の値は登録しない
                        element[columnName] = null;
                    }
                } else {
                    element[columnName] = value;
                }

                //} else {
                //    let di = this.rawSheet.getDataItem(row);
                //    //Editable:falseの場合はうまいことマッチしたアイテムのValueが入っているので、活用する
                //    element[columnName] = value;
                //}


            } else if (column.editor instanceof Spread.Sheets.Style) {

                //!!Excel Export 対応!!

                //日付形式（そのままリクエスト送信するとエラーになる）
                //cellText-- - yyyy/MM/dd文字列
                //cellValue-- - OAdate形式
                //dataSource-- - Date型

                // Date型をそのままjQuery.Ajaxに渡すと、toStringされて、 日付として解釈できないのでJSONの文字列に変換する
                //(new Date()).toString();
                // >>>"Wed Mar 10 2021 09:19:08 GMT+0900 (日本標準時)"←これでリクエストにのり、サーバーエラー
                //
                //(new Date()).toUTCString();
                // >>>"Wed, 10 Mar 2021 00:19:14 GMT"
                //
                // (new Date()).toGMTString();
                // >>>"Wed, 10 Mar 2021 00:19:23 GMT"
                //
                //(new Date()).toJSON()
                // >>>"2021-03-10T00:49:50.829Z"

                //toJSONも考えたが、そのまま文字列を返すようにする

                //よって、文字列でかえしてしまう
                //TODO formatter指定は現状'yyyy/MM/dd'とパスワードしかないが、今後増えてきたら考えましょう（パスワードはtext入れたら全部*******になってしまうのでダメ！）
                if (column.editor.formatter === 'yyyy/MM/dd' || column.editor.formatter === 'yyyy/MM/dd hh:mm:ss') {
                    element[columnName] = text;
                } else {
                    element[columnName] = value;
                }

            } else if (column.editor instanceof ColumnEditor) {
                // #2033編集開始時日付format外の値の表示抑止
                //よって、文字列でかえしてしまう
                //TODO formatter指定は現状'yyyy/MM/dd'とパスワードしかないが、今後増えてきたら考えましょう（パスワードはtext入れたら全部*******になってしまうのでダメ！）
                if (column.editor.displayFormatter === 'yyyy/MM/dd' || column.editor.displayFormatter === 'yyyy/MM/dd hh:mm:ss') {
                    element[columnName] = text;
                } else {
                    element[columnName] = value;
                }
            } else {
                element[columnName] = value;

            }
        }

        return element;
    }

    /**
     * 正規データの取得
     */
    public getProductData(): any[] {

        //return this.rawSheet.getDataSource();
        //SpreadJsか管理しているDataSourceは、操作次第では、滅茶苦茶になってしまう(行移動、追加、範囲貼り付け等...)
        //よって、画面上で目に見えているものを正として、画面項目から、Itemを生成することとした！
        //
        //留意する点は、Key項目はdelete Key等で消されないようにすること!!
        //visible？もしくは拡張プロパティを用意しようかな…(「key」もしくは「readonly」)

        let dataSource = [];
        let rowCount = this.getRowCount()
        for (let row = 0; row < rowCount; row++) {
            let element = this.getProductItem(row);
            dataSource.push(element)
        }
        return dataSource;
    }


    /**
   * 選択行Indexの取得
   */
    getSeletedRowsIndex(): number[] {
        var range = this.rawSheet.getSelections() || [];
        let rows: number[] = [];
        range.forEach((item, i) => {
            for (let j = item.row; j < item.rowCount + item.row; j++) {
                rows.push(j);
            }
        });
        //重複排除。
        rows = _.uniq(rows);
        return rows;
    }

    /**
    * 選択行データの取得
    * @param row
    */
    public getSeletedRowsData(): any[] {
        let dataSource = [];
        let selectedRows = this.getSeletedRowsIndex();
        selectedRows.forEach((index, i) => {
            let element = this.getProductItem(index);
            dataSource.push(element)
        });
        return dataSource;
    }

    /**
     * 保存データの取得
     * ※正規データの取得を行い、見た目上のindexを設定する（見た目上のindexはバリデーションエラー時に使用する）
     */
    public getSaveData(): any[] {
        const dataSource = this.getProductData();
        this.SetVisualIndex(dataSource);

        //!!Excel Export 対応!!
        //getProductData内で、上手く帳尻合わせてしまうこととした！
        //※↑　対応が不十分。画面入力項目ではない項目も対応する為に、念のため行うこととした!!
        //DateはJSON文字列変換する
        //this.convertDateToJSON(dataSource);
        SPIRIT.util.convertDateToJSON(dataSource);

        return dataSource;
    }

    /**
     * 行の元情報を保持
     * (行タグに情報をセット)
     * @param row
     * @param obj
     */
    protected setOriginSourceItem(row: number, obj?: any) {
        // row tag
        if (_.isUndefined(obj)) { obj = null; }
        var tag: { origin: any[], preview: any[] } = this.getTagRowItem(row);
        tag.origin = obj;
        this.rawSheet.setTag(row, -1, tag);
    }

    /**
     * 行の元情報を取得
     *(行タグの情報を取得)
     * @param row
     * @param obj
     */
    private getOriginSourceItem(row: number): any {
        return this.getTagRowItem(row).origin;
    }

    /**
     * 編集後（一つ前）のデータをを保持
     * (行タグに情報をセット)
     * @param row
     * @param obj
     */
    protected setPreviewSourceItem(row: number, obj?: any) {
        // row tag
        if (_.isUndefined(obj)) { obj = null; }
        var tag: { origin: any[], preview: any[] } = this.getTagRowItem(row);
        tag.preview = obj;
        this.rawSheet.setTag(row, -1, tag);
    }

    /**
     * 一つ前の内容を取得
     *(行タグの情報を取得)
     * @param row
     * @param obj
     */
    private getPreviewSourceItem(row: number): any {
        return this.getTagRowItem(row).preview;
    }

    /**
     * 一つ前の内容を保存
     * @param row
     * @param obj
     */
    private savePreviewSourceItem(row: number): any {
        return this.setPreviewSourceItem(row, this.getProductItem(row));
    }


    /**
     * 行の元情報を保持
     * (行タグに情報をセット)
     * @param row
     * @param obj
     */
    protected setTagRowItem(row: number, obj?: { origin: any[], preview: any[], temp?: any }) {
        // row tag
        if (_.isUndefined(obj)) { obj = null; }
        this.rawSheet.setTag(row, -1, obj);
    }

    /**
     * 行の元情報を取得
     *(行タグの情報を取得)
     * @param row
     * @param obj
     */
    private getTagRowItem(row: number): { origin: any[], preview: any[], temp?: any } {
        //行追加での新規行や 複数行選択からの移動にて、もともとあった行のTAGがundefinedになる。
        var tag = this.rawSheet.getTag(row, -1);
        if (_.isNil(tag)) {
            tag = { origin: null, preview: null, temp: null };
            this.setTagRowItem(tag);
        }
        return tag;
        //全てのケースを担保するのは難儀なので、「getTagSourceItem」でnilだった場合にdefaultちを返すようにする
        //return this.rawSheet.getTag(row, -1) || this.BlankRowData;
    }



    /**
     * 行の元情報を保持
     * (行タグに情報をセット)
     * @param row
     * @param obj
     */
    protected setTagCellItem(row: number, col: number, obj?: { origin: any[], preview: any[] }) {
        // row tag
        if (_.isUndefined(obj)) { obj = null; }
        this.rawSheet.setTag(row, col, obj);
    }

    /**
     * 行の元情報を取得
     *(行タグの情報を取得)
     * @param row
     * @param obj
     */
    private getTagCellItem(row: number, col: number): { origin: any[], preview: any[] } {
        //行追加での新規行や 複数行選択からの移動にて、もともとあった行のTAGがundefinedになる。
        var tag = this.rawSheet.getTag(row, col);
        //tag = tag || { origin: null, preview: null };
        tag = tag || {};
        return tag;
    }


    /**
     *　カラム定義を返す
     */
    getColumnDef(col: string | number): columnDef {
        if (_.isString(col)) {
            return _.find(this.columns, c => c.name === col) || {};
        } else {
            return this.columns[col];
        }
    }

    /**
     *　カラムIndex
     */
    getColumnIndex(col: string): number {
        return _.findIndex(this.columns, c => c.name === col);
    }

    /**
     *
     */
    getColumnRange(col): Spread.Sheets.CellRange {
        return this.rawSheet.getRange(-1, col, -1, 1);
    }
    /**
     *
     */
    getRowRange(row): Spread.Sheets.CellRange {
        return this.rawSheet.getRange(row, -1, 1, -1);
    }
    /**
     *
     */
    getColumnStyle(col): Spread.Sheets.Style {
        return this.rawSheet.getStyle(-1, col) || new Spread.Sheets.Style();
    }

    /**
     *
     */
    setColumnStyle(col, style: Spread.Sheets.Style) {
        //return this.rawSheet.setStyle(-1, col, style, Spread.Sheets.SheetArea);
        return this.rawSheet.setStyle(-1, col, style);
    }

    /**
     *
     */
    setColumnDataValidator(col, dv: Spread.Sheets.DataValidation.DefaultDataValidator) {
        return this.rawSheet.getCell(-1, col).validator(dv);
    }

    /**
     *
     */
    getRowStyle(row): Spread.Sheets.Style {
        return this.rawSheet.getStyle(row, -1) || new Spread.Sheets.Style();
    }

    /**
     *
     */
    setRowStyle(row, style: Spread.Sheets.Style) {
        return this.rawSheet.setStyle(row, -1, style);
    }
    /**
     *
     */
    getCellStyle(row, col): Spread.Sheets.Style {
        return this.rawSheet.getStyle(row, col) || new Spread.Sheets.Style();
    }
    /**
     *
     */
    setCellStyle(row, col, style: Spread.Sheets.Style) {
        //return this.rawSheet.setStyle(-1, col, style, Spread.Sheets.SheetArea);
        return this.rawSheet.setStyle(row, col, style);
    }

    /**
     * readonly(列)
     * @param col
     * @param isLocked
     * @param backColor（オプショナル）
    */
    setReadonlyColumn(col, isLocked: boolean, backColor?: string) {

        this.rawSheet.suspendPaint();
        let range = this.getColumnRange(col);
        range.locked(isLocked);
        var color;
        if (isLocked) {
            //色の残しはうまく機能しないだろう（設定の仕方が多方あるので、どの値が正しい値か判断できない為）
            var org = range.backColor() || null;
            range.tag(org);
            if (backColor) {
                color = backColor;
            } else {
                color = SPIRIT.constant.READONLY_BACKCOLOR;
            }
        } else {
            if (backColor) {
                color = backColor;
            } else {
                //nullは許容する
                //color = (range.tag() || range.backColor()) || null;
                color = _.isUndefined(range.tag()) ? range.backColor() : range.tag();
            }
        }
        range.backColor(color);

        //1402 既にLockが掛かっている為必要は無いが.、シート保護無しの場合に備えて、一応実装
        //↓recalcしないと反映されない。効率悪いか（遅かったらやめるこのenabledの処理自体やめる）
        if (range.cellButtons()) {
            _.forEach(range.cellButtons(), (btn: Spread.Sheets.ICellButton) => { btn.enabled = !isLocked });
            this.rawSheet.recalcAll();
        }
        this.rawSheet.resumePaint();
    }

    /**
     * readonly(行)
     * @param row
     * @param isLocked
     * @param backColor（オプショナル）
     */
    setReadonlyRow(row, isLocked: boolean, backColor?: string) {
        this.rawSheet.suspendPaint();

        let range = this.getRowRange(row);
        range.locked(isLocked);
        // rowのTagは生ではえない（使わせない）
        let rowtag = this.getTagRowItem(row);
        var color;
        if (isLocked) {
            //色の残しはうまく機能しないだろう（設定の仕方が多方あるので、どの値が正しい値か判断できない為）
            var org = range.backColor() || null;
            // rowのTagは生ではえない（使わせない）
            //range.tag(org);
            rowtag.temp = rowtag.temp || {}
            rowtag.temp.backColor = org;
            if (backColor) {
                color = backColor;
            } else {
                color = SPIRIT.constant.READONLY_BACKCOLOR;
            }
        } else {
            if (backColor) {
                color = backColor;
            } else {
                //nullは許容する
                color = _.isUndefined(rowtag.temp?.backColor) ? range.backColor() : rowtag.temp?.backColor;
            }
        }
        range.backColor(color);


        //1402 既にLockが掛かっている為必要は無いが.、シート保護無しの場合に備えて、一応実装
        //↓recalcしないと反映されない。効率悪いか（遅かったらやめるこのenabledの処理自体やめる）
        if (range.cellButtons()) {
            _.forEach(range.cellButtons(), (btn: Spread.Sheets.ICellButton) => { btn.enabled = !isLocked });
            this.rawSheet.recalcAll();
        }
        this.rawSheet.resumePaint();

    }

    /**
     * readonly(セル)
     * @param row
     * @param col
     * @param isLocked
     * @param doSuspend
     * @param backColor（オプショナル）
     */
    setReadonly(row, col, isLocked: boolean, doSuspend: boolean, backColor?: string) {

        // #3344 【性能】進捗表(リスト)のパフォーマンス向上
        // 外側でループして呼ぶときに毎回suspendとresumeが繰り返されるため遅くなる場合がある
        if (doSuspend) { this.rawSheet.suspendPaint(); }

        let cell = this.rawSheet.getCell(row, col);
        cell.locked(isLocked);
        var color;
        if (isLocked) {
            //色の残しはうまく機能しないだろう（設定の仕方が多方あるので、どの値が正しい値か判断できない為）
            var org = cell.backColor() || null;
            cell.tag(org);
            if (backColor) {
                color = backColor;
            } else {
                color = SPIRIT.constant.READONLY_BACKCOLOR;
            }
        } else {
            if (backColor) {
                color = backColor;
            } else {
                //nullは許容する
                //color = (cell.tag() || cell.backColor()) || null;
                color = _.isUndefined(cell.tag()) ? cell.backColor() : cell.tag();
            }
        }

        cell.backColor(color);
        //カラムに掛かってると全部非活性になってしまうのでCellの場合やめる
        ////1402 既にLockが掛かっている為必要は無いが.、シート保護無しの場合に備えて、一応実装
        ////↓recalcしないと反映されない。効率悪いか（遅かったらやめるこのenabledの処理自体やめる）
        //if (cell.cellButtons()) {
        //    _.forEach(cell.cellButtons(), (btn: Spread.Sheets.ICellButton) => { btn.enabled = !isLocked });
        //    this.rawSheet.recalcAll();
        //}

        if (doSuspend) { this.rawSheet.resumePaint(); }
    }

    /**
     * コンボボックス
     * @description
     */
    createDropDown(source: Source, textName?: string, valueName?: string, editable?: boolean, editorValueType?: Spread.Sheets.CellTypes.EditorValueType): Spread.Sheets.CellTypes.ComboBox {


        textName = textName || 'text';
        valueName = valueName || 'value';
        editable = editable || false;

        //数値にfalsyは使えない
        //editorValueType = editorValueType || Spread.Sheets.CellTypes.EditorValueType.value;
        if (_.isNil(editorValueType)) {
            editorValueType = Spread.Sheets.CellTypes.EditorValueType.value;
        }

        const combo = new Spread.Sheets.CellTypes.ComboBox();
        combo.editable(editable);
        combo.editorValueType(editorValueType);

        // ドロップダウンリストに入れるデータをセット
        const dropDownDataList = [];

        let p = this.loadSource(source).then(data => {
            for (let item of data) {
                dropDownDataList.push({ text: item[textName], value: item[valueName] });
            }
            combo.items(dropDownDataList);
            source.data = data;

            this.dropDownSources[valueName] = source;
        });

        //※ここで登録しておくと、workBookのMainPromiseに連結されます。
        //非同期で、投げっぱなしで良ければ登録しない
        //上述の「combo.items(dropDownDataList)」のあと、sheet.repaint(refresh) が必要になるが...
        this.registPromises(p);

        return combo;
    }

    /**
     * コンボボックスの作成時のデータ取得
     */
    public getDropDownSources(valueName: string) {
        if (valueName in this.dropDownSources) {
            return this.dropDownSources[valueName].data;
            //return _.cloneDeep(this.dropDownSources[valueName].data);
        } else {
            return [];
        }
    }

    /**
    /**
    * コンボボックスの作成時のデータ設定
     * @param valueName
     * @param value
     */
    public setDropDownSources(valueName: string, value: Source) {

        this.dropDownSources[valueName] = value;
    }

    /**
     * フラグ系コンボボックス型制御用イベント
     */
    createBoolDropDown(): Spread.Sheets.CellTypes.ComboBox {

        // フラグ系項目のコンボ項目
        //boolCombo = [" ", "○"];

        const boolComboItem = [
            //空文字だとSpreadのコンボボックスが機能しないようである
            //{ text: '', value: false },
            //{ text: '-', value: false },
            //{ text: '○', value: true }
            //下記半角スペースで対応
            //#862 Text値未設定のコンボボックスについて(空文字問題解消)
            { text: SPIRIT.codes.Flag.FALSE.value, value: SPIRIT.codes.Flag.FALSE.code },
            { text: SPIRIT.codes.Flag.TRUE.value, value: SPIRIT.codes.Flag.TRUE.code }
        ];
        const combo = new Spread.Sheets.CellTypes.ComboBox();
        combo.editable(false);
        combo.items(boolComboItem);

        combo.editorValueType(Spread.Sheets.CellTypes.EditorValueType.value);

        return combo;
    }


    /**
    * 数値型
    */
    createNumberCellStyle(formatter?: string): Spread.Sheets.Style {
        const style = new Spread.Sheets.Style();
        formatter = formatter || '#,##0';
        style.formatter = formatter;
        style.hAlign = Spread.Sheets.HorizontalAlign.right;
        return style;
    }





    /**
    * カレンダー
    */
    createCalendarCellEditor(displayFormatter = "yyyy/MM/dd", editorFormatter = "yyyy/MM/dd"): ColumnEditor {
        // カレンダードロップダウンリストの作成
        let style = new Spread.Sheets.Style();
        // フォーマットの指定
        style.formatter = displayFormatter;
        style.cellButtons = [
            {
                imageType: Spread.Sheets.ButtonImageType.dropdown,
                command: "openDateTimePicker",
                useButtonStyle: false,
            }
        ];
        style.dropDowns = [
            {
                type: Spread.Sheets.DropDownType.dateTimePicker,
                option: {
                    showTime: false,
                    startDay: Spread.Sheets.CalendarStartDay.sunday,
                }
            }
        ];
        style.formatter = displayFormatter;

        // #2033 編集開始時日付format外の値の表示抑止
        let cellType: DateTimeEditInterceptor = new DateTimeEditInterceptor(editorFormatter);

        let editor = new ColumnEditor();
        editor.displayFormatter = displayFormatter;
        editor.editorFormatter = editorFormatter;

        editor.style = style;
        editor.cellType = cellType;
        return editor
    }



    /**
    * 時刻型
    */
    createTimeCellStyle(): Spread.Sheets.Style {
        // カレンダードロップダウンリストの作成
        let style = new Spread.Sheets.Style();

        // フォーマットの指定
        //style.formatter = "yyyy/MM/dd";
        style.cellButtons = [
            {
                imageType: Spread.Sheets.ButtonImageType.dropdown,
                command: "openTimePicker",
                useButtonStyle: false,
            }
        ];

        style.dropDowns = [
            {
                type: Spread.Sheets.DropDownType.timePicker,
                option: {
                    formatString: "hh:mm"
                }
            }
        ];
        style.formatter = "hh:mm";

        return style;
    }

    /**
    * Time
    */
    createTimePickerCellEditor(displayFormatter = "hh:mm", editorFormatter = "hh:mm"): ColumnEditor {
        // -------------------- Date Time Picker : showTime true ---------------------
        let style = new Spread.Sheets.Style();

        // フォーマットの指定
        style.formatter = displayFormatter;
        style.cellButtons = [
            {
                imageType: Spread.Sheets.ButtonImageType.dropdown,
                command: "openTimePicker",
                useButtonStyle: false,
            }
        ];
        // #4525 保守 10分単位の時刻設定（プルダウン式）に変更
        style.dropDowns = [
            {
                type: Spread.Sheets.DropDownType.timePicker, // リスト内10分刻みはtypeを左記のようにしなければならない
                option: {
                    showTime: true,
                    step: { minute: 10 }, // 10分刻み
                }
            }
        ];

        let cellType: DateTimeEditInterceptor = new DateTimeEditInterceptor(editorFormatter);

        let editor = new ColumnEditor();
        editor.displayFormatter = displayFormatter;
        editor.editorFormatter = editorFormatter;

        editor.style = style;
        editor.cellType = cellType;
        return editor
    }

    /**
    * DateTime
    */
    createDateTimePickerCellEditor(displayFormatter = "yyyy/MM/dd hh:mm:ss", editorFormatter = "yyyy/MM/dd hh:mm:ss"): ColumnEditor {
        // -------------------- Date Time Picker : showTime true ---------------------
        let style = new Spread.Sheets.Style();

        // フォーマットの指定
        style.formatter = displayFormatter;
        style.cellButtons = [
            {
                imageType: Spread.Sheets.ButtonImageType.dropdown,
                command: "openDateTimePicker",
                useButtonStyle: false,
            }
        ];
        style.dropDowns = [
            {
                type: Spread.Sheets.DropDownType.dateTimePicker,
                option: {
                    showTime: true,
                    startDay: Spread.Sheets.CalendarStartDay.sunday,
                }
            }
        ];

        let cellType: DateTimeEditInterceptor = new DateTimeEditInterceptor(editorFormatter);

        let editor = new ColumnEditor();
        editor.displayFormatter = displayFormatter;
        editor.editorFormatter = editorFormatter;

        editor.style = style;
        editor.cellType = cellType;
        return editor
    }

    /**
    * 拡張カラーピッカー型制御
    * #4536
    */
    createColorPickerCellStyle(): Spread.Sheets.Style {

        // -------------------- Custom Calculator ---------------------
        var themeColor = {
            name: 'テーマの色',
            needScaleColor: true,
            colors: [['#ffffff', '#000000', '#e7e6e6', '#44546a', '#5b9bd5', '#ed7d31', '#a5a5a5', '#ffc000', '#4472c4', '#70ad47']]
        }

        var standardColor = {
            name: '標準の色',
            needScaleColor: true,
            colors: [
                ['#C00000', '#FF0000', '#FFC000', '#FFFF00', '#92D050', '#00B050', '#00B0F0', '#0070C0', '#002060', '#7030A0']
            ]
        };

        var customColor = {
            name: 'おすすめ',
            needScaleColor: true,
            colors: [
                //透過の指定は入力エラーになる
                //['#F6ADC6', '#F6BABC', '#FAB27B', '#E761A4', '#F0566E', '#F69896', '#F68B1F', '#F47A55', '#F36C21', '#FB7500', '#d1eefc4a']
                ['#F6ADC6', '#F6BABC', '#FAB27B', '#E761A4', '#F0566E', '#F69896', '#F68B1F', '#F47A55', '#F36C21', '#FB7500']
            ]
        };

        // カラーピッカーの作成
        const style = new Spread.Sheets.Style();
        style.cellButtons = [
            {
                imageType: Spread.Sheets.ButtonImageType.dropdown,
                command: "openColorPicker",
                useButtonStyle: false,
            }
        ];
        style.dropDowns = [
            {
                type: Spread.Sheets.DropDownType.colorPicker,
                option: {
                    colorBlockSize: 15,
                    groups: [
                        themeColor,
                        standardColor,
                        //一旦、利用しない
                        //customColor,
                    ]
                }
            }
        ];

        style.hAlign = Spread.Sheets.HorizontalAlign.left;
        return style;
    }

    /**
     * カラーピッカー型制御用イベント
     * 旧型のカラーピッカー
     */
    createColorPickerCellSimpleStyle(): Spread.Sheets.Style {

        // カラーピッカーの作成
        const style = new Spread.Sheets.Style();
        style.cellButtons = [
            {
                imageType: Spread.Sheets.ButtonImageType.dropdown,
                command: "openColorPicker",
                useButtonStyle: false,
            }
        ];
        style.dropDowns = [
            {
                type: Spread.Sheets.DropDownType.colorPicker,
                option: {
                    colorBlockSize: 15
                }
            }
        ];

        style.hAlign = Spread.Sheets.HorizontalAlign.left;

        return style;
    }

    ///**
    //* カラーピッカー型制御用イベント
    //* @deprecated
    //*/
    //createColorPickerCellStyleWijmo(): Spread.Sheets.Style {
    //    // カラーピッカーの作成
    //    const style = new Spread.Sheets.Style();
    //    style.cellButtons = [
    //        {
    //            imageType: Spread.Sheets.ButtonImageType.dropdown,
    //            useButtonStyle: false,
    //            command: (sheet, row, col, option) => {
    //                //対象とするDOMが存在しない為(spreadのDropDownはCanvasの要素な為)表示方法が無い！
    //                let theColorPicker = new wjcInput.ColorPicker('#theColorPicker', {
    //                    showAlphaChannel: true,
    //                    showColorString: true,
    //                    valueChanged: (sender) => { }
    //                });
    //            }
    //        }
    //    ];
    //    style.hAlign = Spread.Sheets.HorizontalAlign.left;
    //    return style;
    //}


    /**
     * パスワード型制御用イベント
     */
    createPasswordStyle(): Spread.Sheets.Style {

        let style = new Spread.Sheets.Style();
        // フォーマットの指定
        style.formatter = '**;**;**;**';
        style.hAlign = Spread.Sheets.HorizontalAlign.right;
        return style;
    }

    /**
     * パスワード型制御用(編集時も*表示)
     */
    createNoneDisplayPasswordStyle(): ColumnEditor {

        let style = new Spread.Sheets.Style();
        // フォーマットの指定
        style.formatter = '**;**;**;**';
        //style.formatter = '*●;*●;*●;*●';
        style.hAlign = Spread.Sheets.HorizontalAlign.right;
        let cellType: PasswordEditInterceptor = new PasswordEditInterceptor();
        let editor = new ColumnEditor();

        editor.displayFormatter = '**;**;**;**';
        editor.editorFormatter = '**;**;**;**';
        //editor.displayFormatter = '*●;*●;*●;*●';
        //editor.editorFormatter = '*●;*●;*●;*●';

        editor.style = style;
        editor.cellType = cellType;
        return editor
    }

    /**
     *
     * @param col
     * @param sheet
     * @deprecated
     */
    setSectionTypeColumnStyle(sheet: Spread.Sheets.Worksheet) {
        //旧
        //// 区分列の色を変更
        //let cell = sheet.getCell(contentRow, 0, Spread.Sheets.SheetArea.viewport);
        //cell.backColor("#e6e6e6");
        //cell.foreColor("#3f3f3f");
        //cell.borderBottom(new Spread.Sheets.LineBorder("#999", Spread.Sheets.LineStyle.medium));
        //cell.borderRight(new Spread.Sheets.LineBorder("#999", Spread.Sheets.LineStyle.medium));

        // ①スタイルを列に設定します。
        //let style = this.getColumnStyle(col, sheet);
        //style.backColor = "#e6e6e6";
        //style.foreColor = "#3f3f3f";
        //style.borderBottom = new Spread.Sheets.LineBorder("#999", Spread.Sheets.LineStyle.medium);
        //style.borderRight = new Spread.Sheets.LineBorder("#999", Spread.Sheets.LineStyle.medium);
        //this.setColumnStyle(col, style, sheet);

        // ②Range
        //'0'指定は良くない!
        let colRange = this.getColumnRange(0);
        colRange.backColor("#e6e6e6");
        colRange.foreColor("#3f3f3f");
        //colRange.borderBottom(new Spread.Sheets.LineBorder("#999", Spread.Sheets.LineStyle.thin));
        //colRange.borderRight(new Spread.Sheets.LineBorder("#999", Spread.Sheets.LineStyle.thin));
        colRange.borderBottom(new Spread.Sheets.LineBorder("#00000033", Spread.Sheets.LineStyle.thin));
        colRange.borderRight(new Spread.Sheets.LineBorder("#00000033", Spread.Sheets.LineStyle.thin));
    }

    /**
     * データ検証の設定(数式、数式リスト、リスト用)
     * @param column 列定義
     * @param col 列番号
     */
    private setDataFomulaOrListValidator(column: columnDef, col: number) {
        let dv: Spread.Sheets.DataValidation.DefaultDataValidator;
        switch (column.dataFomulaOrListValidator.type) {
            case ValidationType.List:
                dv = Spread.Sheets.DataValidation.createListValidator(column.dataFomulaOrListValidator.value);
                break;
            case ValidationType.Formula:
                dv = Spread.Sheets.DataValidation.createFormulaValidator(column.dataFomulaOrListValidator.value);
                break;
            case ValidationType.FormulaList:
                dv = Spread.Sheets.DataValidation.createFormulaListValidator(column.dataFomulaOrListValidator.value);
                break;
            default:
                break;
        }
        if (dv) {
            // 空白無視するか？
            dv.ignoreBlank(column.dataFomulaOrListValidator.isIgnoreBlank ??= false);
            // 入力メッセージを表示するか？
            dv.showInputMessage(column.dataFomulaOrListValidator.isShowInputMessage ??= false);
            if (dv.showInputMessage()) {
                dv.inputTitle(column.dataFomulaOrListValidator.inputTitle ??= "");
                dv.inputMessage(column.dataFomulaOrListValidator.inputMessage ??= "");
            }
            // エラーメッセージを表示するか？
            dv.showErrorMessage(column.dataFomulaOrListValidator.isShowErrorMessage ??= false);
            if (dv.showErrorMessage()) {
                dv.errorTitle(column.dataFomulaOrListValidator.errorTitle ??= "");
                dv.errorMessage(column.dataFomulaOrListValidator.errorMessage ??= "");
            }
            this.setColumnDataValidator(col, dv);
        }
    }



    /**
     * 指定のカラムにshowEllipsis(...)を設定
     * @param col
     * @param sheet
     * @param value
     */
    showColumnEllipsis(col, value: boolean) {
        let colRange = this.getColumnRange(col);
        colRange.showEllipsis(value);
    }


    /**
    * 色列に背景色を設定する
     * @param sheet
     * @param row
     * @param col
     * @param cellColor
     */
    setColor(sheet: Spread.Sheets.Worksheet, row, col, cellColor: string) {
        // 初期値の色列はライムグリーンにする
        if (cellColor == undefined) { return; }
        let color = _.isNil(cellColor) ? SPIRIT.constant.WORK_BACKCOLOR : cellColor;

        //// 色コード以外が入力されていた場合
        //color = color.toString();
        //if (!color.includes("#")) { return; }

        // colorが色コードではない値が来た場合背景色は変更しない
        if (color.toString().match(/^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/) == null) { return; };

        let lineBorder = new Spread.Sheets.LineBorder('#d8d8d8', Spread.Sheets.LineStyle.thin);
        let cell = sheet.getCell(row, col, Spread.Sheets.SheetArea.viewport);
        cell.setBorder(lineBorder, { outline: true }); // setBorderなるメソッドがあるみたい
        cell.backColor(color);
    }


    /**
     * 
     * @param row
     * @param col
     */
    isDateTimeCell(row, col, cellOnly: boolean = false): boolean {

        let ret = false;
        var style = this.getCellStyle(row, col);
        ret = this.isDateTimePickerStyle(style);
        if (cellOnly) {
            return ret;
        }
        if (!ret) {
            //カラムStyleも検証
            return this.isDateTimeColumn(col);
        }
    }

    /**
     * 
     * @param col
     */
    isDateTimeColumn(col): boolean {
        var style = this.getColumnStyle(col);
        return this.isDateTimePickerStyle(style);
    }
    /**
     * 
     * @param colStyle
     */
    isDateTimePickerStyle(colStyle: Spread.Sheets.Style): boolean {
        //TimePickerは対象外
        //if (colStyle?.dropDowns?.findIndex(v => v.type === Spread.Sheets.DropDownType.dateTimePicker || v.type === Spread.Sheets.DropDownType.timePicker) > -1) {
        if (colStyle?.dropDowns?.findIndex(v => v.type === Spread.Sheets.DropDownType.dateTimePicker) > -1) {
            return true;
        }
        return false;
    }



    /**
    * sheet情報
    */
    public getSheetInfo() {
        //STUB
        return {
            sheetName: this.sheetName,
            columns: this.columns
        }
    }



    /**
    * 現在の順番でSpreadの見た目上のIndex(行番号 -1)を振る。（バリデーション時に使用される）
    * @param list 現在のGridの状態の配列
    */
    protected SetVisualIndex(list: any[]) {

        // 現在の順番でSpreadの見た目上のIndex(行番号 -1)を振る。（バリデーション時に使用される）
        list.forEach((item, index) => {
            item.VisualIndex = index;
        });

        return list;
    }


    /**
    * インポート用並び順設定
    * @param list 
    * @param orderNoKey キー
    */
    public setImportOrderNoKeyVisualIndex(list: any[], orderNoKey: string) {

        const keyList = _.uniq(_.map(list, orderNoKey));

        keyList.forEach((keyValue) => {

            const targetKeyList = list.filter(_ => _[orderNoKey] == keyValue);

            // キー単位で並び順を1から振っていく
            targetKeyList.forEach((item, index) => {
                item['ImportOrderNo'] = index + 1;
            });
        });

        return list;
    }

    /**
     * 変更セル背景色設定（インポート時に使用）
     * @param changeCellList
     */
    setChangeCellBackColor(changeCellList: any[]) {

        this.rawSpread.suspendPaint();

        changeCellList.forEach((item) => {

            // #1150 削除行は変更扱いにしない（背景色を変更色にしない）、ついでに取込区分列も色設定しない
            if (item.importType == SPIRIT.codes.ImportType.DELETED.value || item.colName == WorkSheetBase.KEY_ImportType) { return; }

            const row = item.row;
            const col = this.columns.findIndex(e => e.name === item.colName);
            if (col > -1) {
                this.rawSheet.getCell(row, col).backColor('#FFE38E');
            }
        });

        this.rawSpread.resumePaint();
    }


    /**
     * エラー情報をセット（背景色も）
     * @param changeCellList
     */
    setErrorInfoList(errorInfoList: Array<SPIRIT.interfaces.IErrorInfo>) {

        this.clearErrorInfoList();

        this.errorInfoList = errorInfoList;

        this.setErrorBackColor(false);
    }

    /**
     * エラー情報をクリア（背景色も）
     */
    clearErrorInfoList() {

        this.setErrorBackColor(true);

        this.errorInfoList = [];
    }

    /**
     * エラー情報の背景色設定
     * @param isClear
     */
    private setErrorBackColor(isClear: boolean) {

        this.rawSpread.suspendPaint();

        this.errorInfoList.forEach((item) => {
            const row = item.row;
            let col = item.col;
            if (Array.isArray(item.col)) {
                item.col.forEach((c) => {
                    col = c;
                    this.rawSheet.getCell(row, col).backColor(isClear ? undefined : 'lightpink');
                });
            } else {
                this.rawSheet.getCell(row, col).backColor(isClear ? undefined : 'lightpink');
            }
        });

        this.rawSpread.resumePaint();

    }

    /**
     * Exportするファイルを作成し、コールバックにSpreadのJSONを返却
     * ※一覧形式のみ対応。マトリックス表現するようなものは個別で実装してください！！！
     * @param url データ取得URL
     * @param sheetName シート名
     * @param colInfos カラム情報（取込区分、システムカラムは除く）
     * @param idColName ID列名
     * @param hasImportUserAuth インポート権限を持つユーザか（trueの場合、取込区分がつく）
     * @param cb ダウンロード処理関数
     */
    protected exportSpreadDb(url: string, sheetName: string, colInfos: columnDef[], idColName: string, hasImportUserAuth: boolean, cb, orderNoKey: string = null) {
        // TODO リファクタ 
        SPIRIT.util.getData(url).then((data) => {
            //TODO 日付対応(基本画面を同じ動きをする)
            let _data = this.modelingData(data);
            if (orderNoKey) {
                this.setImportOrderNoKeyVisualIndex(_data, orderNoKey);
            }
            //
            this.exportSpread(_data, sheetName, colInfos, idColName, hasImportUserAuth, cb);
        });
    }

    /**
     *  Exportするファイルを作成し、コールバックにSpreadのJSONを返却
     * @param data データ
     * @param sheetName シート名
     * @param colInfos カラム情報（取込区分、システムカラムは除く）
     * @param idColName ID列名
     * @param hasImportUserAuth インポート権限を持つユーザか（trueの場合、取込区分がつく）
     * @param cb ダウンロード処理関数
     */
    protected exportSpread(data: any[], sheetName: string, colInfos: columnDef[], idColName: string, hasImportUserAuth: boolean, cb) {

        // TODO リファクタ 

        // Spread作成
        const spread = new Spread.Sheets.Workbook(null, { sheetCount: 1 });

        spread.suspendPaint();

        const sheet = spread.getActiveSheet();

        sheet.name(sheetName);
        sheet.autoGenerateColumns = false;
        sheet.setDataSource(data);

        // 取込区分
        const firstFixColInfos: columnDef[] = [{ name: WorkSheetBase.KEY_ImportType, displayName: WorkSheetBase.KEY_ImportType_Display, size: 80 }];
        const firstConcatColInfos = hasImportUserAuth ? firstFixColInfos.concat(colInfos) : colInfos;

        // システムカラム
        const lastColInfos = [
            { name: WorkSheetBase.KEY_UpdateUserName, displayName: WorkSheetBase.KEY_UpdateUserName_Display, size: 150 },
            { name: WorkSheetBase.KEY_UpdateUserLoginId, displayName: WorkSheetBase.KEY_UpdateUserLoginId_Display, size: 100 },
            { name: WorkSheetBase.KEY_UpdateDateString, displayName: WorkSheetBase.KEY_UpdateDateString_Display, size: 200 },
        ];
        const concatColInfos = firstConcatColInfos.concat(lastColInfos);

        sheet.bindColumns(concatColInfos);

        // 列スタイル設定
        concatColInfos.forEach((item, index) => {

            // ヘッダー
            const colHeader = sheet.getRange(0, index, 1, 1, Spread.Sheets.SheetArea.colHeader);

            // 取込区分列のリスト設定
            if (hasImportUserAuth && item.name == WorkSheetBase.KEY_ImportType) {
                const dv = Spread.Sheets.DataValidation.createListValidator(SPIRIT.codes.ImportType.ADDED.value + ',' + SPIRIT.codes.ImportType.EDITED.value + ',' + SPIRIT.codes.ImportType.DELETED.value);
                dv.showErrorMessage(true);
                // ヘッダ行も設定される（行数指定がないので本来はこうするべき）
                //sheet.setDataValidator(-1, index, dv, Spread.Sheets.SheetArea.viewport);
                // ヘッダ行が設定されない方法（行数指定が必要：一旦Excel最大行数は1048576なのでヘッダ数を引いて1048575にする）
                sheet.setDataValidator(0, 0, 1048575, 1, dv, Spread.Sheets.SheetArea.viewport);
            }

            // 列罫線
            const style = new Spread.Sheets.Style();
            style.borderTop = new Spread.Sheets.LineBorder('#000000', Spread.Sheets.LineStyle.thin);
            style.borderBottom = new Spread.Sheets.LineBorder('#000000', Spread.Sheets.LineStyle.thin);
            style.borderLeft = new Spread.Sheets.LineBorder('#000000', Spread.Sheets.LineStyle.thin);
            style.borderRight = new Spread.Sheets.LineBorder('#000000', Spread.Sheets.LineStyle.thin);

            //TODO リファクタcolumnDefに'Id'プロパティを用意！！
            // ID列の背景色指定
            if (hasImportUserAuth && item.name == idColName) {
                style.backColor = '#FFFF00';
            } else {
                // ヘッダー背景色指定
                colHeader.backColor('#E8E8E8');
            }

            //フォーマッタ（日付など）
            //日付対応
            //TODO formatter指定は現状'yyyy/MM/dd'とパスワードしかないが、今後増えてきたら考えましょう（パスワードはtext入れたら全部*******になってしまうのでダメ！）
            //if (item.style?.formatter === 'yyyy/MM/dd') {
            if (item.style?.formatter) {
                style.formatter = item.style.formatter;
            }

            if (item.export?.headerBackColor) {
                // ヘッダー背景色指定
                colHeader.backColor(item.export?.headerBackColor);
            }

            sheet.setStyle(-1, index, style, Spread.Sheets.SheetArea.viewport);
        });

        spread.resumePaint();

        const json = spread.toJSON({ includeBindingSource: true, columnHeadersAsFrozenRows: true });

        if (cb != null) {
            cb(json, spread);
        }
    }


    /**
     * #3875 Multiselect コンボの位置補正コマンド
     * @param sheet
     * @param row
     * @param col
     */
    openMultiSelectListCommand(sheet, row, col) {
        //あくまで、シート領域の(0,0)からのoffsetでしかない。
        let cellRect = sheet.getCellRect(row, col);
        this.rawSpread.commandManager().execute({
            cmd: "openList",
            sheetName: sheet.name(),
            row,
            col
        });

        //提供されたソース、正常に動いてはない。spreadよりも上に別の要素があるだけで、狂う
        //そもそも意味が分からない。無理やり合わせているだけ
        //let dropDownEl: any = document.querySelector(".gc-list-control-container.gc-list-alignment-vertical");
        //dropDownEl.style.overflowY = "scroll";
        //dropDownEl.parentElement.style.position = "absolute";
        //dropDownEl.parentElement.style.top = cellRect.y + cellRect.height + "px";
        //dropDownEl.parentElement.style.left = cellRect.x - cellRect.width - 35 + "px";
        //dropDownEl.style.height = "100px";
        //dropDownEl.style.width = cellRect.width + "px";

        //大枠のDIV
        let hostElement = this.rawSpread.getHost();
        let $dropDownPop = $('.ribbon-dropdowngroup-popup', hostElement);
        //cellRectは spread自身のoffsetが加味されていないので、加算する
        let parentOffsetTop = hostElement.offsetTop;
        let parentOffsetLeft = hostElement.offsetLeft;
        $dropDownPop.css('top', parentOffsetTop + cellRect.y + cellRect.height + 'px');
        $dropDownPop.css('left', parentOffsetLeft + cellRect.x + 'px');
        $dropDownPop.css('width', cellRect.width + 'px');

        //#3979
        //$dropDownPop.css('max-height', '300px');
        //$dropDownPop.css('overflow-y', 'auto');
        let $dropDownEl = $('.gc-list-control-container.gc-list-alignment-vertical', hostElement);
        //他のリスト項目に併せて300とする
        $dropDownEl.css('max-height', '300px');
        $dropDownEl.css('overflow-y', 'auto');
    }




    /**
     * 改行表示可能セルを対象に行の高さを自動調整(インスタンスメソッド)
     * @param row
     * @param correctForExport export用に高さ補正を行う
     */
    autoFitRowForWordWrap(row?: number, correctForExport?: boolean) {
        WorkSheetBase.autoFitRowForWordWrap(this.rawSheet, row, correctForExport);
    }

    /**
     * 改行表示可能セルを対象に行の高さを自動調整（static）
     * @param sheet
     * @param row
     * @param correctForExport export用に高さ補正を行う
     */
    static autoFitRowForWordWrap(sheet: Spread.Sheets.Worksheet, row?: number, correctForExport?: boolean) {

        //ライブラリ本来の処理(autoFit)では、
        //高さ計算関数に渡す/colStyle.fontの値がzoomFactor(拡大率)に応じた値になっている→"12.4667px Calibri"

        //デフォルトでは
        //zoomFactor：1.0、colStyle.font："14.6667px Calibri"
        //
        //0.85だとしたら
        //zoomFactor：0.85、colStyle.font："12.4667px Calibri"
        //で無ければいけないらしい

        //現在の仕様において、デフォルトの拡大率が0.85である為、本来 14.6667*0.85すれば良いのだが、
        //文字列であり、計算し難く、今後何が入ってくるか判らない為、
        //一旦Zoom拡大率を1.0に戻し行の高さを計算設定した後に、元の拡大率に戻すこととした

        //もともとの拡大倍率
        let tempZoomFactor = sheet.zoom();
        //一旦、1.0に戻す
        sheet.zoom(1.0);

        if (_.isNil(row)) {
            //全行対象とする
            for (let row = 0; row < sheet.getRowCount(); row++) {
                //自動調整（正直少しおそくなります。）
                WorkSheetBase.autoFitRowForWordWrapProc(sheet, row, correctForExport);
            }
        } else {
            WorkSheetBase.autoFitRowForWordWrapProc(sheet, row, correctForExport);
        }
        //元の拡大率に戻す
        sheet.zoom(tempZoomFactor);
    }




    /**
     * 改行表示可能セルを対象に行の高さを自動調整（static）
     * @param row
     * @param sheet
     * @param correctForExport
     */
    private static autoFitRowForWordWrapProc(sheet: Spread.Sheets.Worksheet, row: number, correctForExport?: boolean) {

        //高速化対応
        let maxHeight = sheet.defaults.rowHeight;
        for (let col = 0; col < sheet.getColumnCount(); col++) {
            let cell = sheet.getCell(row, col);
            //wordWrap＝trueでかつ、表示されている行に絞り込む
            if (cell.wordWrap() && sheet.getColumnVisible(col)) {
                let colStyle = sheet.getActualStyle(row, col)?.clone() || null;
                let colType = sheet.getCellType(row, col);

                //[注意]
                //zoomを変更せずに下記でもいいが、iphoneとかだともしかしたら変わってくるかもしれないので、一旦止め
                //let zoomFactor = sheet.zoom();
                //let fonts = colStyle.font.split(' ');
                //let fontSize = parseFloat(fonts[0]);
                //fonts[0] = (fontSize * zoomFactor) + 'px';
                //colStyle.font = fonts.join(' ');

                let zoomFactor = 1.0;//1.0固定とする
                let context = cell;
                let desiredHeight = colType.getAutoFitHeight(cell.value(), cell.text(), colStyle, zoomFactor, context);

                //#5740 高さの自動調整にて、少し差異生じたため、spreadJs内部内部を調査した結果 固定で3px分Paddingを追加で与えている事が発覚!!
                if (0 !== desiredHeight) {
                    desiredHeight = Math.ceil(desiredHeight += Math.ceil(3));
                    //#5739
                    if (correctForExport) {
                        desiredHeight *= 1.75;
                    }
                }

                if (maxHeight < desiredHeight) {
                    maxHeight = desiredHeight;
                }
            }
        }
        sheet.setRowHeight(row, maxHeight);
    }




























    /*************************廃棄予定***************************/

    /**
     * 関連項目のDataSource反映
     * @param row
     * @param col
     * @deprecated
     */
    protected applyRelatedTextTarget(rowData: any, row: number, col: number, normalize?: boolean) {

        if (_.isNil(normalize)) { normalize = false; }


        let column = this.getColumnDef(col);

        //コンボボックスエディタの振る舞い方
        if (column.editor instanceof Spread.Sheets.CellTypes.ComboBox) {

            /**重要**** */
            //編集可能で、Spread.Sheets.CellTypes.EditorValueType.valueのコンボボックスは、選択リストに存在しない値を入力した際、
            //cell.value及びDatasource(DataItem)に入力した値が登録されてしまう。（cell.textにも入ります！こっちは見た目上の値なので、取っておく）
            //その為、relatedTargetに入力した値を退避(サーバーリクエスト用)
            if (column.editor.editable() && column.editor.editorValueType() === Spread.Sheets.CellTypes.EditorValueType.value) {

                //console.log('=======================================================');
                //console.log(this.rawSheet.getDataSource()[row]);
                //console.log(rowData);
                //console.log(this.getCell(row, col).text());
                //console.log(this.getCell(row, col).value());
                //console.log('-------------------------------------------------------');


                //現在表示（入力）されたTextを取得
                let text = this.rawSheet.getText(row, col);

                //リクエストする様の値を退避
                if (column.relatedTextTarget && column.relatedTextTarget in rowData) {
                    //関連プロパティがある場合はコンボボックスのText値を直接データソースそのアイテムに設定する
                    rowData[column.relatedTextTarget] = text;
                }

                //(※注意)
                //下記は企画倒れ!!
                //getDataSourceの当該項目の値をクリアにした場合、repaintが走った段階で当然画面上の表示もclearになってしまう。
                //最後リクエストデータを生成する際に、各々で空にする必要がある！！(※注意)


                //選択リストにない項目が入れられている場合、cell.valueに入ってしまった値をクリアにする
                if (normalize) {
                    ////選択リストにあるか判定
                    //column.editor.items();
                    //不用意に入ってしまったcell.value及びDatasource(DataItem)の値をClearする
                    //下記を行うと、Cell.textまでClearされてしまうのでデータソースのみにとどめる
                    //sheet.rawSheet.setValue(row, col, '');
                    //DataSourceのみClear
                    rowData[column.name] = '';
                }

                //一旦変数に入れると、参照切れるみたいなので、再度セットする
                //this.rawSheet.getDataSource()[row] = rowData;

                //console.log(this.rawSheet.getDataSource()[row]);
                //console.log(rowData);
                //console.log(this.getCell(row, col).text());
                //console.log(this.getCell(row, col).value());
                //console.log('=======================================================');
            }
        }

    }

    /**
     *全ての 関連項目のDataSource反映
     * @param criteria
     * @deprecated
     */
    protected applyRelatedTextTargetAll(dataSource: any[], normalize: boolean, criteria?: (coldef: columnDef) => boolean) {

        ////nullの場合も考えられるので、ここは確実にisUndefinedで
        ////if (_.isNil(dataSource)) {
        //if (_.isUndefined(dataSource)) {
        //    debugger;
        //    dataSource = this.rawSheet.getDataSource();
        //}

        let length = this.columns.length;
        for (let col = 0; col < length; col++) {
            let column = this.columns[col]
            if (!criteria || (criteria && criteria(column))) {
                //全行適用
                let rowCount = this.getRowCount();
                for (let row = 0; row < rowCount; row++) {
                    //let rowData = this.rawSheet.getDataItem(row);
                    let rowData = dataSource[row];

                    //関連項目のDataSource反映
                    this.applyRelatedTextTarget(rowData, row, col, normalize);

                    //getDataItemでitemを取得すると、getDataSourcとのe参照切れるみたいなので、再度セットしなければならない
                    //this.rawSheet.getDataSource()[row] = rowData;
                    dataSource[row] = rowData;
                }
            }
        }
    }
}


